import {
  IonHeader, IonPage, IonToolbar, IonTitle, IonContent, withIonLifeCycle, IonFab, IonFabButton,
  IonIcon, IonImg, IonItem, IonText, IonRow, IonCardContent, IonCard, IonCol, IonLabel, IonInput, IonRadioGroup,
  IonRadio, IonCardHeader, IonSelect, IonButton, IonSelectOption
  , IonBadge, IonRange, IonDatetime, IonTextarea
} from '@ionic/react';

import React from 'react';
import * as API from "../utils/api";
import * as apiConstants from "../constants/api-endpoint";
import * as disable from "../constants/disable";
import { Question, Header, QuestionResponse, InspectionQuestions } from "../interface/question.i";
import { camera, chevronBackSharp, diamond, square} from 'ionicons/icons';
import { Plugins } from '@capacitor/core';
import moment from 'moment';
import styled from "styled-components";
import { CustomerDetail } from "../interface/customerDetails.i";
import { CAMERA } from "../utils/shared";
import LogoutPage from './Logout';
import Swal from 'sweetalert2';
import AudioRecoder from '../components/Recorder/AudioRecoder';



const { Camera, Filesystem, VoiceRecorder } = Plugins;

class InspectionPage extends React.Component<any, any> {

  private selectedData: CustomerDetail;
  private pageNmuber: number = 1;
  private previousPageNumber: number = 0;
  private currentPageNumber: number = 0;
  private previousModuleLastPageNumber: number = 0;
  private nextPageNumber: number = 0;
  private maxSequenceNumber: number = 0;
  private disableNextPage: boolean = false;

  constructor(props: any) {
    super(props);
    console.log(" props data ==> ", props);
    this.selectedData = props?.location?.state?.userData;
    this.state = { data: [] as Question[], selectedData: this.selectedData, headerTO: {} as Header, inspectionDetailsTO: {} as InspectionQuestions, originalQuestion: {} as QuestionResponse, audioData: null, value: '',  key: 0}
  }

  componentDidMount() {
    this.invokeQuestionService();
  }


  increment() {
    return this.pageNmuber++;
  }

  decrement() {
    return this.pageNmuber--;
  }

  invokeQuestionService = () => {
    if (this.selectedData && this.selectedData.id) {
      this.questionService(this.selectedData.id, this.pageNmuber);
    }
  }

  //child component
  handleCallback = async (childData: any, index : number) => {
    // Update the data in the component's state
    this.setState({ audioData: childData })
    console.log("childData", childData)
    let name = childData.url;
    const myArray = name.split("blob:http://localhost:8100/");
    console.log(myArray[1]);
    let fileName = myArray[1] + ".wav";
    const file: any = childData;
    const audioFile = new File([file.blob], fileName, { type: 'audio/wav' });
    const formdata = new FormData();
    formdata.append('file1', audioFile);
    this.uploadAudio(await formdata, this.selectedData.id);

  }

  handleChange = (e : any) => {
    const inputText = e.detail.value;
    const numericValue = inputText.replace(/[^0-9]/g, ''); // Remove all non-numeric characters
    this.setState({ value: numericValue });
  };

  //Upload Audio
  uploadAudio(formdata: FormData, id: number) {
    const compartmentType = this.state.data[1].compartmentType;
    const moduleNumber = this.state.inspectionDetailsTO.moduleNumber;
    const uploadAudio = API.authPostRequest(apiConstants.photoUploadUrl + id + '&moduleNumber=' + moduleNumber + '&compartment=' + compartmentType, formdata);
    uploadAudio
      .then(async () => {
        console.log('Audio Uploaded Successfully');
      })
      .catch((error) => {
        console.log(error);
      });
  };

  range = () => {
    const inspectionQuestionTOs = this.state.data as Question[];
    inspectionQuestionTOs.map((el: Question) => {
      if (el.answerType === 'range' || el.answerType == 'range hide' || el.answerType == 'range inches' || el.answerType == 'range gallons' || el.answerType == 'range feet') {
        el.answerValue = (el.answerValue as string).split('-');
        el.label = (el.label as string).split('-');
        el.answer = el.answer.toString();
      }
      // if ((el.answerType === 'range' || el.answerType == 'range hide' || el.answerType == 'range inches' || el.answerType == 'range gallons' || el.answerType == 'range feet') && el.answer != null && el.answer == '0') {
      //   el.answerValue = (el.answerValue as string).split('-');
      //   el.label = (el.label as string).split('-');
      //   el.answer = el.answer.toString();
      // }
    });
  }

  updateInspection = () => {
    //Update inspection values to the database
    this.disableNextPage = false;
    try{
    const inspectionQuestionTOs = this.state.data as Question[];
    inspectionQuestionTOs.map((el: Question) => {
      if(el?.mandatory && (el.answer == null || el.answer == 'NaN')) {
        this.disableNextPage = true;
        this.range();
        throw "mandatory";
      }
      if (el.answerType === 'Choose equipment' || el.answerType === 'drop down' || el.answerType == 'choose drop down' 
      || (el.answerType === 'multiselect' && el.answer === 'null') || (el.answerType === 'drop down multiple' && el.answer === 'null') ||
      (el.answerType === 'checkbox' && el.answer === 'null')) {
        // el.answerValue = el.answerValue.toString();
        el.answerValue = el.answerValue.toString();
      }
      if ((el.answerType === 'range' || el.answerType == 'range hide' || el.answerType == 'range inches' || el.answerType == 'range gallons' || el.answerType == 'range feet') && !isNaN(Number(el.answer))) {
        el.answerValue = (el.answerValue as string[]).join('-');
        el.label = (el.label as string[]).join('-');
        // el.answer = !isNaN(Number(el.answer)) ? el.answer : 0;
        el.answer = el.answer.toString();
      }
      if ((el.answerType == 'calculate' && el.answer != null) || (el.answerType == 'calculateValues' && el.answer != null) || (el.answerType == 'waterVolume' && el.answer != null) || (el.answerType == 'tankCalculate' && el.answer != null)) {
        el.answer = el.answer.toString();
      }
      if(el.answerType == 'radio' && el.answer == 'No' && (el.questionReference == 'interior_plumbing_inspected' || el.questionReference == 'sewer_line_inspected' || el.questionReference == 'single_compartment_inspected' || el.questionReference == 'double_compartment_inspected' || el.questionReference == 'aerobic_inspected'
                                                       || el.questionReference == 'delivery_pipe_inspected' || el.questionReference == 'pump_tank_inspected' || el.questionReference == 'pump_vault_inspected' || el.questionReference == 'peat_moss_inspected' || el.questionReference == 'seepage_pit_inspected' || el.questionReference == 'diverter_valve_inspected' 
                                                       || el.questionReference == 'cess_pool_inspected' || el.questionReference == 'distribution_box_inspected' || el.questionReference == 'grease_trap_inspected' || el.questionReference == 'serial_trench_lateral_inspected' || el.questionReference == 'disposal_bed_inspected' || el.questionReference == 'disposal_trenches_inspected' || el.questionReference == 'pressure_dosed_bed_inspected')) {
          this.state.inspectionDetailsTO.moduleInspected = 'No';
      }
    });
  } catch(exception) {
    console.log("error");
    return;
}

    let update = this.state.originalQuestion;
    let num = this.selectedData.id;
    let name = localStorage.username;
    const updateValues = API.authPostRequest(apiConstants.updateinspection + num + '/' + name, update);
    console.log("url", updateValues);
    updateValues
      .then(async (res) => {
        console.log('Inspection Data Updated Successfully', res);
      })
      .catch((error) => {
        console.log("err===", error);
      });
  }


  gotoNextPage = () => {
    this.setState((prevState : any) => ({ key: prevState.key + 1 }));
    this.updateInspection();
    if(this.disableNextPage == false) {
      this.pageNavigation(this.selectedData.id, this.nextPageNumber, 'nextPage');
    }
  }

  assigndisableFlag(obj:any, index: number) {
      obj[index].disableFlag = true;    
      return obj;
  }

  assigndisableFlagfn(obj:any, length: number) {
    const len = Array(length);
    for (let index = 15; index <= length; index++) {
      obj[index].disableFlag = true;    
    }
    return obj;
  }

  assignenableFlagfn(obj:any, length: number) {
    for (let index = 15; index <= length; index++) {
      obj[index].disableFlag = false;    
    }  
    return obj;
  }


  questionService = (id: number, pNo: number) => {
    // present("Please wait...", 1000);
    this.navigationApiCall(apiConstants.questions + id);
  }

  goBack = () => {
    const lastPageNumber = this.state.inspectionDetailsTO.lastPageNumber;
    const sequenceNumber = this.state.inspectionDetailsTO.sequenceNumber;
    const moduleInspected = this.state.inspectionDetailsTO.moduleInspected;
    const currentModule = this.state.inspectionDetailsTO.currentModule;
    if (this.state.headerTO.title == 'CLIENT INFO AND INSPECTION LOCATION' && this.state.originalQuestion.currentPageNumber == 1) {
      this.props.history.goBack();
    } else if (this.previousPageNumber == 0 && sequenceNumber > 1) {
      this.pageNavigation(this.selectedData.id, lastPageNumber);
    } else if (this.previousPageNumber == 0 && sequenceNumber == 1) {
      this.pageNavigation(this.selectedData.id, this.pageNmuber);
    } else if (this.previousPageNumber == 0 && sequenceNumber == 0) {
      this.pageNavigation(this.selectedData.id, this.pageNmuber);
    } else if (moduleInspected != null && moduleInspected == 'No' && currentModule != null && currentModule != 'Disposal Trenches') {
      this.pageNavigation(this.selectedData.id, 1);
    } else if (moduleInspected != null && moduleInspected == 'No' && currentModule != null && currentModule == 'Disposal Trenches' && this.state.inspectionDetailsTO.currentPageNumber != 2) {
      this.pageNavigation(this.selectedData.id, 2);
    }  else if (moduleInspected != null && moduleInspected == 'No' && currentModule != null && currentModule == 'Disposal Trenches' && this.state.inspectionDetailsTO.currentPageNumber == 2) {
      this.pageNavigation(this.selectedData.id, 1);
    } else {
      this.pageNavigation(this.selectedData.id, this.previousPageNumber);
    }

  }

  pageNavigation = (id: number, pNo: number, nav?: string) => {
    // present("Please wait...", 1000);
    const currentModule = this.state.inspectionDetailsTO.currentModule;
    const moduleNumber = this.state.inspectionDetailsTO.moduleNumber;
    const typeFromBackEnd = this.state.inspectionDetailsTO.typeFromBackEnd;
    const typeFromUI = this.state.inspectionDetailsTO.typeFromUI;
    const previousModule = this.state.inspectionDetailsTO.previousModule;
    const moduleInspected = this.state.inspectionDetailsTO.moduleInspected;
    let repetitiveModule = "No"
    if(previousModule == 'Sewer Line' || previousModule == 'Disposal Trenches' || previousModule == 'Peat Moss' || previousModule == 'Serial Trench Lateral'
     || previousModule == 'Grease Trap' || previousModule == 'Seepage Pit') {
      repetitiveModule = "Yes";
    }
    const previousmoduleNumber = this.state.inspectionDetailsTO.previousModuleNumber;
    const previousmoduleLastPageNumber = this.state.inspectionDetailsTO.previousModuleLastPageNumber;
    const currentPageNumber = this.state.inspectionDetailsTO.currentPageNumber;
    const lastPageNumber = this.state.inspectionDetailsTO.lastPageNumber;
    const previousPageNumber = this.state.inspectionDetailsTO.previousPageNumber;
    let sequenceNumber = this.state.originalQuestion.headerTO.sequenceNumber;
    let maxSequenceNumber = this.state.headerTO.maxSequenceNumber;
    const sequenceNum = 0;
    const direction = "backward";
    let url = '';
    if ((currentModule != previousModule && previousPageNumber == 0 && repetitiveModule == 'Yes') && (sequenceNumber == 0 || sequenceNumber == 1)) {
      url = apiConstants.inspectionquestions + id + '&page=' + previousmoduleLastPageNumber + '&currentModule=' + previousModule + '&moduleNumber=' + previousmoduleNumber + '&direction=' + direction + '&sequenceNumber=' + sequenceNum + '&user=' + localStorage.username;
    }

    if ((currentModule != previousModule && previousPageNumber == 0 && repetitiveModule == 'No') && (sequenceNumber == 0 || sequenceNumber == 1)) {
      url = apiConstants.inspectionquestions + id + '&page=' + previousmoduleLastPageNumber + '&currentModule=' + previousModule + '&moduleNumber=' + previousmoduleNumber + '&direction=' + direction + '&sequenceNumber=' + sequenceNumber + '&user=' + localStorage.username;
    }

    if (previousPageNumber != 0 && sequenceNumber == 0) {
      url = apiConstants.inspectionquestions + id + '&page=' + pNo + '&currentModule=' + currentModule + '&moduleNumber=' + moduleNumber + '&typeFromBackEnd=' + typeFromBackEnd+ '&typeFromUI=' + typeFromUI + '&direction=' + direction + '&sequenceNumber=' + maxSequenceNumber + '&user=' + localStorage.username;
    }

    if (previousPageNumber != 0 && sequenceNumber != 0) {
      url = apiConstants.inspectionquestions + id + '&page=' + pNo + '&currentModule=' + currentModule + '&moduleNumber=' + moduleNumber + '&typeFromBackEnd=' + typeFromBackEnd+ '&typeFromUI=' + typeFromUI + '&direction=' + direction + '&sequenceNumber=' + sequenceNumber + '&user=' + localStorage.username;
    }

    if (previousPageNumber == 0 && sequenceNumber > 1) {
      url = apiConstants.inspectionquestions + id + '&page=' + pNo + '&currentModule=' + currentModule + '&moduleNumber=' + moduleNumber + '&typeFromBackEnd=' + typeFromBackEnd+ '&typeFromUI=' + typeFromUI + '&direction=' + direction + '&sequenceNumber=' + sequenceNumber + '&user=' + localStorage.username;
    }

    if(currentModule == 'Disposal Trenches' && currentPageNumber == 2 && sequenceNumber > 1) {
      maxSequenceNumber = sequenceNumber - 1;
      url = apiConstants.inspectionquestions + id + '&page=' + lastPageNumber + '&currentModule=' + currentModule + '&moduleNumber=' + moduleNumber + '&typeFromBackEnd=' + typeFromBackEnd+ '&typeFromUI=' + typeFromUI + '&direction=' + direction + '&sequenceNumber=' + maxSequenceNumber + '&user=' + localStorage.username;
    }

    if((currentModule == 'Sewer Line' || currentModule == 'Peat Moss' || currentModule == 'Grease Trap' || currentModule == 'Seepage Pit' || currentModule == 'Serial Trench Lateral' || currentModule == 'Disposal Trenches') 
       && currentPageNumber == 1 && sequenceNumber > 1) {
      maxSequenceNumber = sequenceNumber - 1;
      url = apiConstants.inspectionquestions + id + '&page=' + lastPageNumber + '&currentModule=' + currentModule + '&moduleNumber=' + moduleNumber + '&typeFromBackEnd=' + typeFromBackEnd+ '&typeFromUI=' + typeFromUI + '&direction=' + direction + '&sequenceNumber=' + maxSequenceNumber + '&user=' + localStorage.username;
    }

    if(currentModule != null && (currentModule == 'Cancel' || currentModule == 'Notes')) {
      url = apiConstants.inspectionquestions + id + '&page=' + previousmoduleLastPageNumber + '&currentModule=' + previousModule + '&moduleNumber=' + previousmoduleNumber + '&direction=' + direction + '&sequenceNumber=' + sequenceNumber + '&user=' + localStorage.username;
    }

    if (nav === "nextPage") {
      url = apiConstants.inspectionquestions + id + '&page=' + pNo + '&currentModule=' + currentModule + '&moduleNumber=' + moduleNumber + '&typeFromBackEnd=' + typeFromBackEnd+ '&typeFromUI=' + typeFromUI + '&direction=forward' + '&sequenceNumber=' + sequenceNumber + '&user=' + localStorage.username;
    }

    if (nav === "nextPage" && moduleInspected != null && moduleInspected == 'No') {
      url = apiConstants.inspectionquestions + id + '&page=' + lastPageNumber + '&currentModule=' + currentModule + '&moduleNumber=' + moduleNumber + '&typeFromBackEnd=' + typeFromBackEnd+ '&typeFromUI=' + typeFromUI + '&direction=forward' + '&sequenceNumber=' + sequenceNumber + '&user=' + localStorage.username;
    }

    this.navigationApiCall(url)
  }

  navigationApiCall = (url: string) => {
    API.authGetRequest(url, '')
      .then((res) => {
        if (res && res.data) {
          const responseData = res.data;
          //responseData.headerTO = this.state.originalQuestion.headerTO;
          this.previousPageNumber = responseData.previousPageNumber;
          this.nextPageNumber = responseData.nextPageNumber;
          this.currentPageNumber = responseData.currentPageNumber;
          this.maxSequenceNumber = responseData.headerTO.maxSequenceNumber;
          const data = responseData.inspectionQuestionTOs as Question[];

          if (data && data.length) {
            data.map((o, i) => {
              if (o.answerType === 'range' || o.answerType == 'range inches' || o.answerType == 'range gallons'
                || o.answerType == 'range feet') {
                const str = o.answerValue as string;
                const label = o.label as string;
                // o.answer = !isNaN(Number(o.answer)) ? o.answer : 0;
                o.answer = o.answer ? o.answer : '0';
                o.answerValue = str.split('-').map(Number);
                if (label) {
                  o.label = label.split('-');
                }
              }
              if(this.state.inspectionDetailsTO.currentModule == 'Static Information' && this.currentPageNumber == 2) {
                if (data[4].questionReference == 'type_of_building' && data[4].answer != null && data[4].answer == 'Residential') {
                  const inspectionQuestionTOs = this.assigndisableFlag(responseData.inspectionQuestionTOs, 6);
                  responseData.inspectionQuestionTOs = inspectionQuestionTOs;
                }
                if (data[4].questionReference == 'type_of_building' && data[4].answer != null && data[4].answer == 'Non Residential') {
                  const inspectionQuestionTOs = this.assigndisableFlag(responseData.inspectionQuestionTOs, 5);
                  responseData.inspectionQuestionTOs = inspectionQuestionTOs;
                }
                if (data[14].questionReference == 'building_occupied' && data[14].answer != null && data[14].answer == 'Yes') {
                  const inspectionQuestionTOs = this.assigndisableFlag(responseData.inspectionQuestionTOs, 16);
                  responseData.inspectionQuestionTOs = inspectionQuestionTOs;
                }else if (data[14].questionReference == 'building_occupied' && data[14].answer != null && data[14].answer == 'No') {
                  const inspectionQuestionTOs = this.assigndisableFlag(responseData.inspectionQuestionTOs, 15);
                  responseData.inspectionQuestionTOs = inspectionQuestionTOs;
                }
                if (data[1].questionReference == 'building_built_year' && (data[1].answer != null || data[1].answer != "")) {
                  data[0].answer = 'Known';
                }else {
                  data[0].answer = 'Unknown';
                }
                if (data[3].questionReference == 'system_built_year' && (data[3].answer != null  || data[3].answer != "")) {
                  data[2].answer = 'Known';
                }else {
                  data[2].answer = 'Unknown';
                }
              }
            })
          }
          console.log("allIns===", res);
          this.setState({
            inspectionDetailsTO: responseData.inspectionDetailsTO,
            headerTO: responseData.headerTO,
            data: responseData.inspectionQuestionTOs,
            originalQuestion: responseData
          }) 
          if (data && data.length) {
            data.map((o, i) => {
              this.dropdownOnChange(o, i)
              this.radioOnchange(o, i)
              if(o.answerType == 'range gallons') {
                this.rangeUpdate(o, i)
              }
           })
        }      
        }
      })
      .catch((error) => {
        console.log("err===", error);
      });
  }

  // Update the Answers to the respective Questions
  originalQuestionUpdate = (answer: any, index: number) => {
    const updatedData = { ...this.state.originalQuestion };
    if (updatedData && updatedData.inspectionQuestionTOs.length > index && updatedData.inspectionQuestionTOs[index]) {
      updatedData.inspectionQuestionTOs[index].answer = answer;
      this.setState({
        originalQuestion: updatedData
      });
      console.log(answer);
    }
  }

  rangeQuestionUpdate = (answer: any, index: number) => {
    const updatedData = { ...this.state.originalQuestion };
    if (updatedData && updatedData.inspectionQuestionTOs.length > index && updatedData.inspectionQuestionTOs[index]) {
      updatedData.inspectionQuestionTOs[index].answer = (!isNaN(Number(answer)) ? answer : '0');
      this.setState({
        originalQuestion: updatedData
      });
      console.log(answer);
    }
  }

  textOnChange = (event: any, index: number) => {
    const updatedData = { ...this.state.originalQuestion };
    if (updatedData && updatedData.inspectionQuestionTOs.length > index && updatedData.inspectionQuestionTOs[index]) {
      updatedData.inspectionQuestionTOs[index].answer = event;

      //1 Compartment Round Logics
      if((this.currentPageNumber == 3 && updatedData.inspectionDetailsTO.currentModule == '1 Compartment') || (this.currentPageNumber == 4 && updatedData.inspectionDetailsTO.currentModule == '2 Compartment') || (this.currentPageNumber == 2 && updatedData.inspectionDetailsTO.currentModule == 'Grease Trap')
       || this.currentPageNumber == 2 && updatedData.inspectionDetailsTO.currentModule == 'Seepage Pit') {
        if(updatedData.inspectionQuestionTOs[index].mobileView == 'Depth of Liquid (in inches)' && updatedData.inspectionQuestionTOs[index - 3].answer == 'Round') {
          updatedData.inspectionQuestionTOs[index].answer = event;
          let diameter = updatedData.inspectionQuestionTOs[index - 1].answer - 6;
          let radius = diameter/2;
          let height = updatedData.inspectionQuestionTOs[index].answer;
          let labelAnswer = (3.14159 * radius * radius * height) / 231;
          let roundOff = Math.round(labelAnswer);
          if (roundOff >= 900 && roundOff <= 1160) {
            roundOff = 1000;
          } else if (roundOff > 1160 && roundOff <= 1270) {
            roundOff = 1250;
          } else if (roundOff > 1270 && roundOff <= 1400) {
            roundOff = 1300;
          } else if (roundOff > 1400 && roundOff <= 1625) {
            roundOff = 1500;
          } else if (roundOff > 1625 && roundOff <= 1875) {
            roundOff = 1750;
          } else if (roundOff > 1875) {
            roundOff = 2000;
          }
          updatedData.inspectionQuestionTOs[index + 3].answer = roundOff;
        }
        //Seepage pit round logics (Tank Volume)
        if(updatedData.inspectionQuestionTOs[index].mobileView == 'Height of Tank (in inches)' && updatedData.inspectionQuestionTOs[index - 2].answer == 'Round') {
          updatedData.inspectionQuestionTOs[index].answer = event;
          let diameter = updatedData.inspectionQuestionTOs[index - 1].answer - 6;
          let radius = diameter/2;
          let height = updatedData.inspectionQuestionTOs[index].answer;
          let water = updatedData.inspectionQuestionTOs[index + 1].answer;
          let tankVolume = (3.14159 * radius * radius * height) / 231;
          let roundOff = Math.round(tankVolume);
          if (roundOff >= 900 && roundOff <= 1160) {
            roundOff = 1000;
          } else if (roundOff > 1160 && roundOff <= 1270) {
            roundOff = 1250;
          } else if (roundOff > 1270 && roundOff <= 1400) {
            roundOff = 1300;
          } else if (roundOff > 1400 && roundOff <= 1625) {
            roundOff = 1500;
          } else if (roundOff > 1625 && roundOff <= 1875) {
            roundOff = 1750;
          } else if (roundOff > 1875) {
            roundOff = 2000;
          }
          updatedData.inspectionQuestionTOs[index + 4].answer = roundOff;
        }
         //Seepage pit round logics (Water Volume)
         if(updatedData.inspectionQuestionTOs[index].mobileView == 'Depth of water (in inches)' && updatedData.inspectionQuestionTOs[index - 3].answer == 'Round') {
          updatedData.inspectionQuestionTOs[index].answer = event;
          let diameter = updatedData.inspectionQuestionTOs[index - 2].answer - 6;
          let radius = diameter/2;
          let height = updatedData.inspectionQuestionTOs[index].answer;
          let waterVolume = (3.14159 * radius * radius * height) / 231;
          let roundOff = Math.round(waterVolume);
          if (roundOff >= 900 && roundOff <= 1160) {
            roundOff = 1000;
          } else if (roundOff > 1160 && roundOff <= 1270) {
            roundOff = 1250;
          } else if (roundOff > 1270 && roundOff <= 1400) {
            roundOff = 1300;
          } else if (roundOff > 1400 && roundOff <= 1625) {
            roundOff = 1500;
          } else if (roundOff > 1625 && roundOff <= 1875) {
            roundOff = 1750;
          } else if (roundOff > 1875) {
            roundOff = 2000;
          }
          updatedData.inspectionQuestionTOs[index + 4].answer = roundOff;
          updatedData.inspectionQuestionTOs[index + 5].answer = updatedData.inspectionQuestionTOs[index + 3].answer - updatedData.inspectionQuestionTOs[index + 4].answer;
        }
         //Seepage pit rectangle logics (Tank Volume)
         if(updatedData.inspectionQuestionTOs[index].mobileView == 'Width of Tank (in inches)' && updatedData.inspectionQuestionTOs[index - 5].answer == 'Square') {
          updatedData.inspectionQuestionTOs[index].answer = event;
          let length = updatedData.inspectionQuestionTOs[index - 1].answer -6;
          let breadth = updatedData.inspectionQuestionTOs[index].answer - 6;
          let height = updatedData.inspectionQuestionTOs[index - 3].answer;
          let labelAnswer = (length * breadth * height) / 231;
          console.log("labelAnswer=",labelAnswer);
          let roundOff = Math.round(labelAnswer);
          if (roundOff >= 900 && roundOff <= 1160) {
            roundOff = 1000;
          } else if (roundOff > 1160 && roundOff <= 1270) {
            roundOff = 1250;
          } else if (roundOff > 1270 && roundOff <= 1400) {
            roundOff = 1300;
          } else if (roundOff > 1400 && roundOff <= 1625) {
            roundOff = 1500;
          } else if (roundOff > 1625 && roundOff <= 1875) {
            roundOff = 1750;
          } else if (roundOff > 1875) {
            roundOff = 2000;
          }
          updatedData.inspectionQuestionTOs[index + 1].answer = roundOff;
        }
          //Seepage pit rectangle logics (Water Volume)
          if(updatedData.inspectionQuestionTOs[index].mobileView == 'Width of Tank (in inches)' && updatedData.inspectionQuestionTOs[index - 5].answer == 'Square') {
            updatedData.inspectionQuestionTOs[index].answer = event;
            let length = updatedData.inspectionQuestionTOs[index - 1].answer -6;
            let breadth = updatedData.inspectionQuestionTOs[index].answer - 6;
            let height = updatedData.inspectionQuestionTOs[index - 2].answer;
            let labelAnswer = (length * breadth * height) / 231;
            console.log("labelAnswer=",labelAnswer);
            let roundOff = Math.round(labelAnswer);
            if (roundOff >= 900 && roundOff <= 1160) {
              roundOff = 1000;
            } else if (roundOff > 1160 && roundOff <= 1270) {
              roundOff = 1250;
            } else if (roundOff > 1270 && roundOff <= 1400) {
              roundOff = 1300;
            } else if (roundOff > 1400 && roundOff <= 1625) {
              roundOff = 1500;
            } else if (roundOff > 1625 && roundOff <= 1875) {
              roundOff = 1750;
            } else if (roundOff > 1875) {
              roundOff = 2000;
            }
            updatedData.inspectionQuestionTOs[index + 2].answer = roundOff;
            updatedData.inspectionQuestionTOs[index + 3].answer = updatedData.inspectionQuestionTOs[index + 1].answer - updatedData.inspectionQuestionTOs[index + 2].answer;
          }
        //1 Compartment Rectangle Logics
        if(updatedData.inspectionQuestionTOs[index].mobileView == 'Width of Tank (in inches)' && updatedData.inspectionQuestionTOs[index - 5].answer == 'Rectangle') {
          updatedData.inspectionQuestionTOs[index].answer = event;
          let length = null;
          if(updatedData.inspectionQuestionTOs[index - 4].answer == 'Yes') {
            length = updatedData.inspectionQuestionTOs[index - 1].answer - 9;
          } else {
            length = updatedData.inspectionQuestionTOs[index - 1].answer - 6;
          }
          let breadth = updatedData.inspectionQuestionTOs[index].answer - 6;
          let height = updatedData.inspectionQuestionTOs[index - 2].answer;
          let labelAnswer = (length * breadth * height) / 231;
          console.log("labelAnswer=",labelAnswer);
          let roundOff = Math.round(labelAnswer);
          if (roundOff >= 900 && roundOff <= 1160) {
            roundOff = 1000;
          } else if (roundOff > 1160 && roundOff <= 1270) {
            roundOff = 1250;
          } else if (roundOff > 1270 && roundOff <= 1400) {
            roundOff = 1300;
          } else if (roundOff > 1400 && roundOff <= 1625) {
            roundOff = 1500;
          } else if (roundOff > 1625 && roundOff <= 1875) {
            roundOff = 1750;
          } else if (roundOff > 1875) {
            roundOff = 2000;
          }
          updatedData.inspectionQuestionTOs[index + 1].answer = roundOff;
        }
      }
    }
    this.originalQuestionUpdate(event, index);
  }

  handleKeyPress = (event : any) => {
    if (event.key === 'Enter') {
      // Prevent the default behavior (form submission) on Enter press
      event.preventDefault();

      // Do something when the Enter key is pressed
      return true;
    }
  };

  OnChangeRadio = (event: any, id: number, index: number, pageno: number) => {

    //To display questions based on radiobutton values choosen
    const val = event.detail.value;
    if (val != null) {
      console.log("radio value", val);
      const lastPage = this.state.inspectionDetailsTO.lastPageNumber;
      if (val != null && val == 'Yes' && this.state.data[index].answerType == 'choose addon' && this.state.data[index].compartmentType != 'Disposal Trenches') {
        this.sequenceNumberUpdate(event.detail.value, index);
        this.pageNavigation(id, 1, 'nextPage');
      }
      if (val != null && val == 'Yes' && this.state.data[index].answerType == 'choose addon' && this.state.data[index].compartmentType == 'Disposal Trenches') {
        this.sequenceNumberUpdate(event.detail.value, index);
        this.pageNavigation(id, 2, 'nextPage');
      }
      if (val != null && val == 'No' && this.state.data[index].answerType == 'choose addon') {
        this.sequenceNumberUpdate(event.detail.value, index);
        this.pageNavigation(id, lastPage, 'nextPage');
      }
      this.originalQuestionUpdate(event.detail.value, index);
      this.updateInspection();
    };
  }
  
  // Need to re-write the code
  radioOnchange = (event: any, index: number) => {
    // if (!event?.detail?.value) return;
    const updateEvent = this.state.data as Question[];
    let selectedQuestion = event?.target?.innerText;
    let selectedAnswer = event?.detail?.value;
    if(event?.mobileView) {
      selectedQuestion = event.mobileView;
      selectedAnswer = event.answer;
    }
    // this.disableMandatoryFlag(); 
    if (selectedQuestion.indexOf('Age Of Building') > -1 || selectedQuestion.indexOf('Accessed by Inspector') > -1 || selectedQuestion.indexOf('Exterior cleanout access') > -1
      || selectedQuestion.indexOf('Is That Tank Clear Of Obstructions') > -1 || selectedQuestion.indexOf('Liquid level') > -1
      || selectedQuestion.indexOf('Condition of panel') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'age_of_building' || el.questionReference == 'accessed_by_inspector' || el.questionReference == 'exterior_cleanout_access' || el.questionReference == 'exterior_cleanout_access1'
          || el.questionReference == 'exterior_cleanout_access2' || el.questionReference == 'is_that_tank_clear_of_obstructions' || el.questionReference == 'liquid_level' || el.questionReference == 'trash_compartment_lid'
          || el.questionReference == 'condition_of_panel' || el.questionReference == 'liquid_level_aeration') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Known" || selectedAnswer == 'No' || selectedAnswer == 'Buried' || selectedAnswer == 'Unsat') {
          if(disable.ageOfBuilding.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.photo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          } else if(disable.location.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == "Unknown" || selectedAnswer == 'Yes' || selectedAnswer == 'Exposed' || selectedAnswer == 'Sat') {
          if(disable.buildingBuiltYear.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.locPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          } else if(disable.locationPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Age Of System') > -1 
      || selectedQuestion.indexOf('Is The Outlet Baffle Fully accessible for Maintenance') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'system_age' || el.questionReference == 'condition_of_sewer_line1' || el.questionReference == 'condition_of_sewer_line2' || el.questionReference == 'lid_cond'
          || el.questionReference == 'another_condition_of_lid' || el.questionReference == 'is_the_outlet_baffle_fully_accessible_for_maintenance') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Known" || selectedAnswer == 'Unsat' || selectedAnswer == 'No') {
          if(disable.ageOfSystem.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.agefSystemPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == "Unknown" || selectedAnswer == 'Sat' || selectedAnswer == 'Yes') {
          if(disable.ageOfSystemUnknown.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of Inlet baffle') > -1 || selectedQuestion.indexOf('Condition of sewer line') > -1 || selectedQuestion.indexOf('Is the lid exposed') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'condition_of_inlet_baffle' || el.questionReference == 'condition_of_sewer_line' || el.questionReference == 'is_the_lid_exposed') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unsat' || (selectedAnswer == 'No' && el.compartmentType == 'Peat Moss')) {
          if(disable.inlet.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
          if(disable.unsatPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;  
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Sat' || selectedAnswer == 'Unknown/ Not Visible' || (selectedAnswer == 'Yes' && el.compartmentType == 'Peat Moss')) {
          if(disable.unsatInlet.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.sewerLine.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Unknown') {
          if(disable.unknown.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of Riser') > -1 || selectedQuestion.indexOf('Condition of riser') > -1 || selectedQuestion.indexOf('Condition of Effluent Filter') > -1 || selectedQuestion.indexOf('Is there Standing water') > -1
      || selectedQuestion.indexOf('Condition of second pump/siphon') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'condition_of_riser' || el.questionReference == 'condition_of_riser1' || el.questionReference == 'condition_of_effluent_filter'
          || el.questionReference == 'is_there_standing_water' || el.questionReference == 'condition_of_second_pump_siphon' || el.questionReference == 'standing_water' || el.questionReference == 'standing_water1' || el.questionReference == 'standing_water2') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unsat' || selectedAnswer == 'Yes') {
          if(disable.riser.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Sat' || selectedAnswer == 'Unknown' || selectedAnswer == 'No' || selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.riserSat.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('System History') > -1 || selectedQuestion.indexOf('Is There A Riser') > -1 || selectedQuestion.indexOf('Were One or More of the Lids, Opened For Inspection') > -1
     || selectedQuestion.indexOf('Will a filter slide into existing baffle') > -1 || selectedQuestion.indexOf('Was This Pipe Uncovered') > -1 || selectedQuestion.indexOf('Is The Lid Exposed') > -1 || selectedQuestion.indexOf('Is there a second pump') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'repair_history' || el.questionReference == 'there_riser' || el.questionReference == 'is_there_a_riser' || el.questionReference == 'is_there_a_riser1' || el.questionReference == 'is_there_a_risers' || el.questionReference == 'another_is_there_a_riser' || el.questionReference == 'were_one_or_more_of_the_lids_opened_for_inspection'
         || el.questionReference == 'will_a_filter_slide_into_existing_baffle' || el.questionReference == 'is_there_a_riser1' || el.questionReference == 'was_this_pipe_uncovered' || el.questionReference == 'is_the_lid_exposed' || el.questionReference == 'is_there_a_second_pump') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Yes" || selectedAnswer == "Repairs") {
          if(disable.systemHistory.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.riserPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          } else if(disable.upgradeBaffle.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == "No" || selectedAnswer == "Replacement") {
          if(disable.repair.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.upgradeBaffleFilter.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.repairYear.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          }
        } else if (selectedAnswer == 'No History') {
          switch (el.questionReference) {
            case 'repair_completed':
            case 'year_of_repair':
              el.disableFlag = true;
              el.hideElement = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Is the Building currently occupied') > -1 || selectedQuestion.indexOf('Is there Another Lid in Compartment1') > -1 || selectedQuestion.indexOf('Is There Another Lid') > -1 || selectedQuestion.indexOf('Is the system a candiate for service program') > -1
      || selectedQuestion.indexOf('Evidence of sewage overflow') > -1 || selectedQuestion.indexOf('Were One or More of the Lids opened For Inspection') > -1 || selectedQuestion.indexOf('Was the D-Box uncovered') > -1 || selectedQuestion.indexOf('Air filter condition') > -1 || selectedQuestion.indexOf('Condition of Pump') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'building_occupied' || el.questionReference == 'is_there_another_lid' || el.questionReference == 'is_the_system_a_candiate_for_service_program' || el.questionReference == 'evidence_of_sewage_overflow' || el.questionReference == 'were_one_or_more_of_the_lids_opened_for_inspection1' || el.questionReference == 'dbox_uncovered'
          || el.questionReference == 'air_filter_condition' || el.questionReference == 'condition_of_pump_siphon') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Yes" || selectedAnswer == 'Unsat' || selectedAnswer == "yes") {
          if(disable.anotherLid.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.anotherLidPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          } else if(disable.dateOccupied.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == "No" || selectedAnswer == 'Sat' || selectedAnswer == "no" || selectedAnswer == 'N/A') {
          if(disable.anotherLidSat.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.reasons.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.dateLastOccupied.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Unknown') {
          switch (el.questionReference) {
            case 'how_many_occupants':
            case 'date_last_occupied':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Has the Septic Tank Been Pumped Regularly') > -1 || selectedQuestion.indexOf('Was GPS used') > -1 || selectedQuestion.indexOf('Is There An Effluent Filter') > -1 || selectedQuestion.indexOf('Is The Tank Clear Of Obstructions') > -1 || selectedQuestion.indexOf('Was trash compartment pumped') > -1
      || selectedQuestion.indexOf('Condition of Aerator') > -1 || selectedQuestion.indexOf('Conditions of ground surface over Cess Pool') > -1 || selectedQuestion.indexOf('Location of alarm box') > -1 || selectedQuestion.indexOf('Conditions of ground surface over disposal area') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'tank_pumped_regularly' || el.questionReference == 'gps_used' || el.questionReference == 'is_there_an_Effluent_Filter' || el.questionReference == 'is_that_tank_clear_of_obstructions1' || el.questionReference == 'was_trash_compartment_pumped' || el.questionReference == 'condition_of_aerator' || el.questionReference == 'conditions_of_ground_surface_over_cess_pool' || el.questionReference == 'location_of_alarm_box' || el.questionReference == 'conditions_of_ground_surface_over_disposal_area'
          || el.questionReference == 'conditions_of_ground_surface_over_disposal_area1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Yes" || selectedAnswer == 'Unsat' || selectedAnswer == 'Interior') {
          if(disable.latitude.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } 
          if(disable.lastPumping.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          } 
          if(disable.filterSlide.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == "No" || selectedAnswer == 'Unknown' || selectedAnswer == 'Sat' || selectedAnswer == 'Exterior') {
          if(disable.lastPumpingSat.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } 
          if(disable.serPrgmCandidate.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } 
          if(disable.obstruction.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Is a Filter lid needed') > -1 || selectedQuestion.indexOf('Condition of Valve') > -1 || selectedQuestion.indexOf('Is the d-box Clear Of Obstructions') > -1 || selectedQuestion.indexOf('Is the aerobic tank free of obstructions') > -1 || selectedQuestion.indexOf('Aeration Lid') > -1
      || selectedQuestion.indexOf('Condition of Doghouse') > -1 || selectedQuestion.indexOf('Is It Clear of obstructions') > -1 || selectedQuestion.indexOf('Location of electrical connections') > -1 || selectedQuestion.indexOf('Condition of pump floats') > -1 || selectedQuestion.indexOf('Terminating Inspection at any point') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'is_filter_lid_needed' || el.questionReference == 'condition_of_valve' || el.questionReference == 'dbox_clr_of_obstructions' || el.questionReference == 'free_of_obstructions' || el.questionReference == 'aeration_lid' || el.questionReference == 'condition_of_doghouse' || el.questionReference == 'is_it_clear_of_obstructions' || el.questionReference == 'is_it_clear_of_obstructions1' || el.questionReference == 'location_of_electrical_connections' || el.questionReference == 'condition_of_pump_floats'
          || el.questionReference == 'terminate_inspection_final') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Yes" || selectedAnswer == 'Unsat' || selectedAnswer == 'Exterior') {
          if(disable.exterior.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.obstructionPhoto.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == "No" || selectedAnswer == 'Sat' || selectedAnswer == 'Interior' || selectedAnswer == 'N/A') {
          if(disable.interior.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.obstructions1.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.obstructionPhoto1.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == "Exposed" && el.compartmentType == 'Aerobic') {
          if(disable.exposed.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == "Buried" && el.compartmentType == 'Aerobic') {
          if(disable.buried.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Is a Riser needed') > -1 || selectedQuestion.indexOf('Condition Of Lid') > -1 || selectedQuestion.indexOf('Condition of the Lid') > -1 || selectedQuestion.indexOf('Was Aeration chamber pumped') > -1 || selectedQuestion.indexOf('Interior Of Cesspool') > -1 || selectedQuestion.indexOf('Was This Grease trap Pumped') > -1 || selectedQuestion.indexOf('Condition of alarm float') > -1
      || selectedQuestion.indexOf('Vent pipes') > -1 || selectedQuestion.indexOf('Standing water in port') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'is_riser_needed' || el.questionReference == 'condition_of_lid' || el.questionReference == 'condition_of_lid1' || el.questionReference == 'another_condition_of_lid' || el.questionReference == 'condition_of_lids' || el.questionReference == 'condition_of_Lid' || el.questionReference == 'was_aeration_chamber_pumped' || el.questionReference == 'interior_Of_cesspool' || el.questionReference == 'was_this_grease_trap_pumped' || el.questionReference == 'was_this_grease_trap_pumped1' || el.questionReference == 'condition_of_alarm_floats'
          || el.questionReference == 'vent_pipes' || el.questionReference == 'vent_pipes1' || el.questionReference == 'standing_water_in_port' || el.questionReference == 'standing_water_in_port1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Yes" || selectedAnswer == 'Unsat') {
          if(disable.riserHeight.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } 
          if(disable.ventPipe.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          } 
          if(disable.reasonNotPumped.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } 
          if(disable.singleCompLidCond.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } 
          if(disable.singleCompLidCondPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
          if(disable.secondCompLindCond.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } 
          if(disable.secondCompLindCondPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == "No" || selectedAnswer == 'Sat' || selectedAnswer == 'N/A' || selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.heightOfRiser.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } 
          if(disable.reasonNotPumped.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
          if(disable.singleCompLidCond.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } 
          if(disable.singleCompLidCondPhoto.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
          if(disable.secondCompLindCond.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } 
          if(disable.secondCompLindCondPhoto.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Outlet baffle') > -1 || selectedQuestion.indexOf('Was The Lid Opened For Inspection') > -1 || selectedQuestion.indexOf('When float was lifted did alarm sound') > -1 || selectedQuestion.indexOf('Evidence of sewage overflow and or surfacing') > -1 || selectedQuestion.indexOf('Distribution plate and Tipping plate') > -1 || selectedQuestion.indexOf('Break out on ground surface') > -1 || selectedQuestion.indexOf('Is there a monitoring port within this trench') > -1 || selectedQuestion.indexOf('Is there more than one (1) seepage pit') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'outlet_baffle' || el.questionReference == 'outlet_baffles' || el.questionReference == 'was_the_lid_opened_for_inspection' || el.questionReference == 'was_the_lid_opened_for_inspection1' || el.questionReference == 'when_float_was_lifted_did_alarm_sound' || el.questionReference == 'evidence_of_sewage_overflow_and_or_surfacing' || el.questionReference == 'evidence_of_sewage_overflow_and_or_surfacing1'
          || el.questionReference == 'distribution_plate_tipping_plate' || el.questionReference == 'distribution_plate_tipping_plate1' || el.questionReference == 'break_out_on_ground_surface' || el.questionReference == 'break_out_on_ground_surface1' || el.questionReference == 'is_there_a_monitoring_port_within_this_trench' || el.questionReference == 'is_there_a_monitoring_port_within_this_trench1' || el.questionReference == 'more_than_one_pit' || el.questionReference == 'more_than_one_pit1' || el.questionReference == 'more_than_one_pit2') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Unsat" || selectedAnswer == 'No') {
          if(disable.outlet.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.distributionPlate.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          } else if(disable.sewegeOverflow.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == "Sat" || selectedAnswer == 'Yes' || selectedAnswer == 'N/A' || selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.unsatOutlet.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.sewegeOverflow1.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.brkOutPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Unknown') {
          switch (el.questionReference) {
            case 'if_yes_confirmed_by_who':
            case 'if_not_determined_why':
              el.disableFlag = true;
              el.hideElement = false;

              el.mandatory = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Inlet baffle') > -1 || selectedQuestion.indexOf('Aerator pipe') > -1 || selectedQuestion.indexOf('Is the lid exposed') > -1 || selectedQuestion.indexOf('Is there a deep port') > -1 || selectedQuestion.indexOf('Conditions of ground surface over disposal trenches') > -1 || selectedQuestion.indexOf('Confirmed standing water within the Trench') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'inlet_baffle' || el.questionReference == 'is_the_lid_buried_or_exposed1' || el.questionReference == 'is_the_lid_exposed' || el.questionReference == 'is_the_lid_exposed1' || el.questionReference == 'is_there_a_deep_port' || el.questionReference == 'is_there_a_deep_port1' || el.questionReference == 'conditions_of_ground_surface_over_disposal_trench' || el.questionReference == 'confirmed_standing_water_within_the_trench' || el.questionReference == 'conditions_of_ground_surface_over_disposal_trench1'
          || el.questionReference == 'confirmed_standing_water_within_the_trench1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Unsat" || selectedAnswer == 'Buried' || (selectedAnswer == 'Yes' && el.compartmentType != 'Peat Moss')) {
          if(disable.sixInchLateral.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.overflowPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          } else if(disable.buriedDepth.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == "Sat" || selectedAnswer == 'Exposed' || (selectedAnswer == 'No' && el.compartmentType != 'Peat Moss') || selectedAnswer == 'Unknown' || selectedAnswer == 'Unknown/ Not Visible' || selectedAnswer == 'N/A') {
          if(disable.sixInchLateral1.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.buriedDepth.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of Electrical Connections') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'condition_of_electrical_connections') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Unsat") {
          if(disable.elecConnection.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == "Sat" || selectedAnswer == 'Unknown') {
          if(disable.elecConnection.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Evidence of overflow') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'evidence_of_overflow' || el.questionReference == 'evidence_of_overflow1' || el.questionReference == 'overflow' || el.questionReference == 'overflow1') {
          el.answer = selectedAnswer;
        }
        if ((selectedAnswer == 'Yes' && el.compartmentType != 'Peat Moss')) {
          if(disable.overflowPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if ((selectedAnswer == 'No' && el.compartmentType != 'Peat Moss')) {
          if(disable.overflowPhoto.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Are there corner ports within the bed') > -1 || selectedQuestion.indexOf('Water breaking out on the surface') > -1 || selectedQuestion.indexOf('Is the pit clear of obstructions') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'are_there_corner_ports_within_the_bed' || el.questionReference == 'are_there_corner_ports_within_the_bed1' || el.questionReference == 'water_breaking_out_on_the_surface' || el.questionReference == 'water_breaking_out_on_the_surface1'
          || el.questionReference == 'clr_of_obstruction' || el.questionReference == 'clr_of_obstruction1' || el.questionReference == 'clr_of_obstruction2' || el.questionReference == 'liquid_level_aeration') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Unsat" || selectedAnswer == 'No') {
          if(disable.obstructions.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.cornerPorts.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = true;
            el.mandatory = false;
          } else if(disable.obstructionsPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == "Sat" || selectedAnswer == 'Yes') {
          if(disable.obstructionPhoto1.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.noOfCornerPorts.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.waterBreaking.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Is the Area clear of obstructions') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'is_the_area_clear_of_obstructions') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'No') {
          if(disable.obstructions.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.obstructionsPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Yes') {
          if(disable.obstructions.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } 
          if(disable.obstructionsPhoto.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Liquid Level') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'liquid_level' || el.questionReference == 'liquid_level_aeration') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Unsat") {
          if(disable.liquidLevel.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == "Sat" || selectedAnswer == "Unknown") {
          if(disable.liquidLevel.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('1 Compartment lid') > -1 || selectedQuestion.indexOf('2 Compartment lid') > -1) {
      updateEvent.map((el: Question) => {
        if ((el.compartmentType == '1 Compartment' || el.compartmentType == '2 Compartment') && (el.questionReference == 'lid' || el.questionReference == 'Lid_is' || el.questionReference == 'another_lid_is')) {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Buried" && (el.compartmentType == '1 Compartment' || el.compartmentType == '2 Compartment')) {
          if(disable.singleComplid.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
          if(disable.doubleCompLid.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == "Exposed" && (el.compartmentType == '1 Compartment' || el.compartmentType == '2 Compartment')) {
          if(disable.singleComplid.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
          if(disable.doubleCompLid.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
      if (selectedQuestion.indexOf('Compartment 2 lid') > -1) {
        updateEvent.map((el: Question) => {
          if (el.questionReference == 'Lid_is') {
            el.answer = selectedAnswer;
          }
          if (selectedAnswer == "Buried") {
            if(disable.doubleCompLid.includes(el.questionReference)) {
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
            }
          } else if (selectedAnswer == "Exposed") {
            if(disable.doubleCompLid.includes(el.questionReference)) {
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
            }
          }
        });
        this.setState({
          data: updateEvent
        });
      }
    }
    if (selectedQuestion.indexOf('Liquid level') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'liguid_level') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Unsat") {
          if(disable.liquidLevel.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == "Sat") {
          if(disable.liquidLevel.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Tank Condition') > -1 || selectedQuestion.indexOf('Condition of Peat Moss') > -1 || selectedQuestion.indexOf('Is there standing water in corner port') > -1 || selectedQuestion.indexOf('Conditions of ground surface over disposal trenches') > -1 || selectedQuestion.indexOf('Access lid') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'tank_condition' || el.questionReference == 'module_is_free_of_obstructions1'
          || el.questionReference == 'condition_of_peat_moss' || el.questionReference == 'condition_of_peat_moss1' || el.questionReference == 'is_there_standing_water_in_corner_ports' || el.questionReference == 'is_there_standing_water_in_corner_ports1' || el.questionReference == 'conditions_of_ground_surface_over_disposal_trench' || el.questionReference == 'conditions_of_ground_surface_over_disposal_trench1' || el.questionReference == 'access_lid' || el.questionReference == 'access_lid1' || el.questionReference == 'access_lid2') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "No" || selectedAnswer == 'N/A' || selectedAnswer == 'Sat' || selectedAnswer == 'Exposed' || selectedAnswer == 'Unknown' || selectedAnswer == 'Unable to determined' || selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.tankConditionSat.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.obs.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' || selectedAnswer == 'Unsat' || selectedAnswer == 'Buried' || selectedAnswer == 'Approx length') {
          if(disable.tankConditionUnsat.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.peatMossPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          } else if(disable.obs.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Is There A Difference Between The Design & Volume Removed') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'is_there_a_difference_between_the_design_and_volume_removed' || el.questionReference == 'is_there_a_difference_between_the_design_and_volume_removed1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "No" || selectedAnswer == 'N/A') {
          if(disable.reasonForDifference.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Yes') {
          if(disable.reasonForDifference.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of lid') > -1 || selectedQuestion.indexOf('Condition of module') > -1 || selectedQuestion.indexOf('How many disposal beds serve the home') > -1 || selectedQuestion.indexOf('Is the water within 6" of the laterals') > -1 || selectedQuestion.indexOf('Condition of seepage pit') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'condition_of_lid' || el.questionReference == 'condition_of_lid1' || el.questionReference == 'condition_of_module' || el.questionReference == 'condition_of_module1' || el.questionReference == 'how_many_disposal_beds_serve_the_home' || el.questionReference == 'how_many_disposal_beds_serve_the_home1' || el.questionReference == 'is_the_water_within_six_of_the_laterals' || el.questionReference == 'is_the_water_within_six_of_the_laterals1' || el.questionReference == 'six_inch_of_the_lateral' || el.questionReference == 'six_inch_of_the_lateral1' || el.questionReference == 'water_within_six_inches' || el.questionReference == 'water_within_six_inches1' || el.questionReference == 'cond_of_lid'
          || el.questionReference == 'seepage_pit_condition' || el.questionReference == 'cond_of_lid1' || el.questionReference == 'cond_of_lid2' || el.questionReference == 'seepage_pit_condition1' || el.questionReference == 'seepage_pit_condition2') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Sat' || selectedAnswer == 1 || selectedAnswer == 'No' || selectedAnswer == 'Unable to determined' || selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.lidSat.includes(el.questionReference)) {
            el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false; 
          } else if(disable.laterals.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
          }
        } else if (selectedAnswer == 'Unsat' || selectedAnswer == 2 || selectedAnswer == 'Yes' || selectedAnswer == 'Approx length') {
          if(disable.lidUnsat.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.photoModule.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Is there a riser') > -1 || selectedQuestion.indexOf('Condition of lateral pipe') > -1 || selectedQuestion.indexOf('Confirmed standing water within the disposal bed') > -1 || selectedQuestion.indexOf('Condition of lateral pipe') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'is_there_a_riser' || el.questionReference == 'is_there_a_riser1' || el.questionReference == 'condition_of_laterals' || el.questionReference == 'condition_of_laterals1' || el.questionReference == 'confirmed_standing_water_within_the_disposal_bed' || el.questionReference == 'confirmed_standing_water_within_the_disposal_bed1'
          || el.questionReference == 'condition_of_lateral_pipe' || el.questionReference == 'condition_of_lateral_pipe1' || el.questionReference == 'riser' || el.questionReference == 'riser1' || el.questionReference == 'riser2') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Yes' || selectedAnswer == 'Unsat') {
          if(disable.isRiser.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.photoRiser.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No' || selectedAnswer == 'Sat' || selectedAnswer == 'Unknown') {
          if(disable.isRiserNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Delivery pipe condition') > -1 || selectedQuestion.indexOf('Riser Condition') > -1 || selectedQuestion.indexOf('Condition of the Riser') > -1 || selectedQuestion.indexOf('Aeration chamber water level') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'delivery_pipe_condition' || el.questionReference == 'riser_cond' || el.questionReference == 'another_condition_of_riser' || el.questionReference == 'condition_of_riser' || el.questionReference == 'another_condition_of_riser' || el.questionReference == 'condition_of_riser1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unsat') {
          if(disable.dpipeUnsat.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.dpipePhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Sat') {
          if(disable.dpipeSat.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Is there standing water') > -1 || selectedQuestion.indexOf('Trash compartment Lid') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'standing_water' || el.questionReference == 'standing_water1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unsat' || selectedAnswer == 'Yes' || selectedAnswer == 'Buried') {
          if(disable.riserCondUnsat.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Sat' || selectedAnswer == 'No' || selectedAnswer == 'Exposed') {
          if(disable.riserCondUnsat.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Riser condition') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'cond_of_riser' || el.questionReference == 'riser_condition' || el.questionReference == 'condition_of_riser') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unsat') {
          if(disable.riserCondUnsat.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Sat') {
          if(disable.riserCondUnsat.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if ((selectedQuestion.indexOf('Riser Condition') > -1 && updateEvent[index].compartmentType == 'Seepage Pit') || selectedQuestion.indexOf('Conditions of ground surface over seepage pit') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'cond_of_riser' || el.questionReference == 'cond_of_riser1' || el.questionReference == 'cond_of_riser2' || el.questionReference == 'cond_of_gro_sur' || el.questionReference == 'cond_of_gro_sur1' || el.questionReference == 'cond_of_gro_sur2') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unsat') {
          if(disable.riserConditionUnsat.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.UnsatRiserPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          }
        } else if (selectedAnswer == 'Sat' || selectedAnswer == 'No') {
          if(disable.riserConditionSat.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Type of Building') > -1 || selectedQuestion.indexOf('Condition of Outlet Baffle') > -1 || selectedQuestion.indexOf('Riser Condition') > -1 || selectedQuestion.indexOf('Condition of deep ports') >-1 || selectedQuestion.indexOf('Was the Underground utility Mark-out Completed') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'type_of_building' || el.questionReference == 'condition_of_outlet_baffle' || el.questionReference == 'condition_of_riser' || el.questionReference == 'cond_of_deep_ports' || el.questionReference == 'mark_out_completed') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Residential' || selectedAnswer == 'Unsat' || selectedAnswer == 'No') {
          if(disable.residential.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.nonResidential.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
          }
        } else if (selectedAnswer == 'Non Residential' || selectedAnswer == 'Sat' || selectedAnswer == 'Unknown' || selectedAnswer == 'Unknown/ Not Visible' || selectedAnswer == 'Yes') {
          if(disable.nonResidential.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          } else if(disable.residential.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of Riser') > -1 || selectedQuestion.indexOf('Condition of riser') > -1 || selectedQuestion.indexOf('Signs of lush vegetation') > -1 || selectedQuestion.indexOf('Was there a file review in the Health Dept') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'riser_condition' || el.questionReference == 'riser_condition1' || el.questionReference == 'condition_of_riser' || el.questionReference == 'condition_of_riser1' || el.questionReference == 'signs_of_lush_vegetation' || el.questionReference == 'file_review_health_dept') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unsat' || selectedAnswer == 'Yes') {
          if(disable.reasonUnsat.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.vegetationPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          } else if(disable.notWhy.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
          }
        } else if (selectedAnswer == 'Sat' || selectedAnswer == 'No' || selectedAnswer == 'It was attemped') {
          if(disable.sat.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.vegetationPhoto.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.notWhy.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Are there any obstructions above the sewer line') > -1 || selectedQuestion.indexOf('Proposed slide in Type') > -1 || selectedQuestion.indexOf('Air pressure available') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'obstructions_sewer_line' || el.questionReference == 'proposed_slide_in_type' || el.questionReference == 'air_pressure_available') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Yes' || selectedAnswer == 'Poly' || selectedAnswer == 'Buried') {
          if(disable.obstructionName.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.takePhotosOfObstructions.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          } else if(disable.proposedSlideBristle.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No' || selectedAnswer == 'Bristle' || selectedAnswer == 'N/A' || selectedAnswer == 'Exposed') {
          if(disable.proposedSlidePoly.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.proposedSlideBristle.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Last Pumping Date') >-1 || selectedQuestion.indexOf('How many disposal beds serve the home') >-1 || selectedQuestion.indexOf('Shape of Tank') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'cond_of_corner_ports' || el.questionReference == 'how_many_disposal_beds_serve_the_home' || el.questionReference == 'shape_of_tank') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unsat' || selectedAnswer == 'Known' || selectedAnswer == 2 || selectedAnswer == 'Round' || selectedAnswer == 'Yes') {
          if(disable.portsUnsat.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } 
          if(disable.lastPumpingDate.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          } 
          if(disable.dividerWall.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Sat' || selectedAnswer == 'Unknown' || selectedAnswer == 1 || selectedAnswer == 'Rectangle' || selectedAnswer == 'No') {
          if(disable.portsSat.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } 
          if(disable.tankDepth.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Lid condition') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'condition_of_lid') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unsat') {
          if(disable.doubleCompLidCond.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
          if(disable.doubleCompLidCondPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Sat') {
          if(disable.doubleCompLidCond.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
          if(disable.doubleCompLidCondPhoto.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Evidence of Sewage Overflow') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'evidence_of_sewage_overflow') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Yes') {
          if(disable.sewegePhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No') {
          if(disable.sewegePhoto.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Cespool lid') > -1 || selectedQuestion.indexOf('Was The Cesspool Pumped during inspection') > -1 || selectedQuestion.indexOf('Condition of lateral interior') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'was_the_cesspool_pumped_during_inspection' || el.questionReference == 'lid_is' || el.questionReference == 'cond_of_lat_interior') {
          el.answer = selectedAnswer;
        }
        if ((el.compartmentType == 'Cess Pool' && selectedAnswer == 'Buried') || selectedAnswer == 'No' || selectedAnswer == 'Sat with concerns') {
          if(disable.lid.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if ((el.compartmentType == 'Cess Pool' && selectedAnswer == 'Exposed') || selectedAnswer == 'Yes' || selectedAnswer == 'Sat' || selectedAnswer == 'Unknown') {
          if(disable.lid.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Pump tank lid') > -1 || selectedQuestion.indexOf('Pump vault lid') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'is_lid_exposed') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Buried') {
          if(disable.pumpTankLid.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Exposed') {
          if(disable.pumpTankLid.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of lid') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'condition_of_lid' || el.questionReference == 'lid_cond' || el.questionReference == 'another_condition_of_lid') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unsat') {
          if(disable.lidCond.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
          if(disable.singleCompLidCond.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
          if(disable.singleCompLidCondPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Sat') {
          if(disable.lidCond.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
          if(disable.singleCompLidCond.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
          if(disable.singleCompLidCondPhoto.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Is There an overflow pipe') > -1 || selectedQuestion.indexOf('Condition of the lid') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'is_there_an_overflow_pipe' || el.questionReference == 'condition_of_lid') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Yes' || selectedAnswer == 'Unsat') {
          if(disable.ports.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'No' || selectedAnswer == 'Sat') {
          if(disable.noPorts.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Does the tank have ports') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'ports' || el.questionReference == 'ports1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Yes') {
          if(disable.tankPorts.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'No') {
          if(disable.tankPorts.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of Ports') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'ports_condition' || el.questionReference == 'ports_condition1' || el.questionReference == 'cond_of_corner_ports') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unsat') {
          if(disable.unsatPorts.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Sat') {
          if(disable.unsatPorts.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(selectedQuestion.indexOf('Was This Tank Pumped during inspection') > -1 || selectedQuestion.indexOf('Is the Lid Buried or Exposed') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'was_this_tank_pumped_during_inspection' || el.questionReference == 'is_the_lid_buried_or_exposed') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Yes' || selectedAnswer == 'Buried') {
          if(disable.tankPumped.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.notPumped.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No' || selectedAnswer == 'Exposed') {
          if(disable.tankPumped.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.notPumped.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(selectedQuestion.indexOf('Length of trench') > -1 || selectedQuestion.indexOf('Module is free of obstructions') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'length_of_trench' || el.questionReference == 'module_is_free_of_obstructions') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unable to determined' || selectedAnswer == 'Yes') {
          if(disable.trench.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Approx length' || selectedAnswer == 'No') {
          if(disable.trench.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(selectedQuestion.indexOf('Interior Plumbing inspected') > -1 || selectedQuestion.indexOf('Sewer Line inspected') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'interior_plumbing_inspected' || el.questionReference == 'sewer_line_inspected') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == 'Interior Plumbing') {
          if(disable.intPlumbingInspectedYes.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == 'Interior Plumbing') {
          if(disable.intPlumbingInspectedYes.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == 'Sewer Line') {
          if(disable.sewerLineInspectedYes.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == 'Sewer Line') {
          if(disable.sewerLineInspectedYes.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } 
          if(disable.sewerLineInspectedYesPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(selectedQuestion.indexOf('1 Compartment Inspected') > -1 || selectedQuestion.indexOf('2 Compartment Inspected') > -1 || selectedQuestion.indexOf('Aerobic Inspected') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'single_compartment_inspected' || el.questionReference == 'double_compartment_inspected' || el.questionReference == 'aerobic_inspected') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == '1 Compartment') {
          if(disable.singleCompInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == '1 Compartment') {
          if(disable.singleCompInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == '2 Compartment') {
          if(disable.doubleCompInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == '2 Compartment') {
          if(disable.doubleCompInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == 'Aerobic') {
          if(disable.aerobicInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == 'Aerobic') {
          if(disable.aerobicInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(selectedQuestion.indexOf('Delivery Pipe Inspected') > -1 || selectedQuestion.indexOf('Distribution Box Inspected') > -1 || selectedQuestion.indexOf('Pump Tank Inspected') > -1 || selectedQuestion.indexOf('Pump Vault Inspected') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'delivery_pipe_inspected' || el.questionReference == 'distribution_box_inspected' || el.questionReference == 'pump_tank_inspected' || el.questionReference == 'pump_vault_inspected') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'No' &&  (this.state.inspectionDetailsTO.currentModule == 'Delivery Pipe' || this.state.inspectionDetailsTO.currentModule == 'Delivery Pipe DV1' || this.state.inspectionDetailsTO.currentModule == 'Delivery Pipe DV2')) {
          if(disable.delPipeInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  (this.state.inspectionDetailsTO.currentModule == 'Delivery Pipe' || this.state.inspectionDetailsTO.currentModule == 'Delivery Pipe DV1' || this.state.inspectionDetailsTO.currentModule == 'Delivery Pipe DV2')) {
          if(disable.delPipeInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == 'Distribution Box') {
          if(disable.distributionBoxInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == 'Distribution Box') {
          if(disable.distributionBoxInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == 'Pump Tank') {
          if(disable.pumpTankInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == 'Pump Tank') {
          if(disable.pumpTankInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == 'Pump Vault') {
          if(disable.pumpVaultInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == 'Pump Vault') {
          if(disable.pumpVaultInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(selectedQuestion.indexOf('Peat Moss Inspected') > -1 || selectedQuestion.indexOf('Seepage Pit Inspected') > -1 || selectedQuestion.indexOf('Diverter Valve Inspected') > -1 || selectedQuestion.indexOf('Cess Pool Inspected') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'peat_moss_inspected' || el.questionReference == 'seepage_pit_inspected' || el.questionReference == 'diverter_valve_inspected' || el.questionReference == 'cess_pool_inspected') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == 'Peat Moss') {
          if(disable.peatMossInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == 'Peat Moss') {
          if(disable.peatMossInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == 'Seepage Pit') {
          if(disable.seepagePitInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == 'Seepage Pit') {
          if(disable.seepagePitInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == 'Diverter Valve') {
          if(disable.diverterValveInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == 'Diverter Valve') {
          if(disable.diverterValveInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == 'Cess Pool') {
          if(disable.cesspoolInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == 'Cess Pool') {
          if(disable.cesspoolInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(selectedQuestion.indexOf('Disposal Bed Inspected') > -1 || selectedQuestion.indexOf('Pressure Dosed Bed Inspected') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'disposal_bed_inspected' || el.questionReference == 'pressure_dosed_bed_inspected') {
          el.answer = selectedAnswer;
        }
       if (selectedAnswer == 'No' && (this.state.inspectionDetailsTO.currentModule == 'Disposal Bed' || this.state.inspectionDetailsTO.currentModule == 'Pressure Dosed Bed')) {
          if(disable.disposalBedInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' && (this.state.inspectionDetailsTO.currentModule == 'Disposal Bed' || this.state.inspectionDetailsTO.currentModule == 'Pressure Dosed Bed')) {
          if(disable.disposalBedInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(selectedQuestion.indexOf('Disposal Trenches Inspected') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'disposal_trenches_inspected') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == 'Disposal Trenches') {
          if(disable.disposalTrenchInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == 'Disposal Trenches') {
          if(disable.disposalTrenchInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } 
          if(disable.disposalTrenchPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(selectedQuestion.indexOf('Grease Trap Inspected') > -1 || selectedQuestion.indexOf('Serial Trench Lateral Inspected') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'grease_trap_inspected' || el.questionReference == 'serial_trench_lateral_inspected') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == 'Grease Trap') {
          if(disable.greaseTrapInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == 'Grease Trap') {
          if(disable.greaseTrapInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'No' &&  this.state.inspectionDetailsTO.currentModule == 'Serial Trench Lateral') {
          if(disable.serialTrenchInspected.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Yes' &&  this.state.inspectionDetailsTO.currentModule == 'Serial Trench Lateral') {
          if(disable.serialTrenchInspected.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.intPlumbingInspectedNo.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(!event?.mobileView) {
      this.originalQuestionUpdate(event.detail.value, index);
      }
  }

  disableMandatoryFlag = () => {
    this.disableNextPage = false;
  }

  // Need to re-write the code
  dropdownOnChange = (event: any, index: number) => {
    //Logics to hide & disable questions based on dropdown question and answer choosen
    // if (!event?.detail?.value || !event?.mobileView) return;
    const updateEvent = this.state.data as Question[];
    let selectedQuestion = event?.target?.ariaLabel;
    let selectedAnswer = event?.detail?.value;
    if(event?.mobileView) {
      selectedQuestion = event.mobileView;
      selectedAnswer = event.answer;
    }
    // this.disableMandatoryFlag();
    if (selectedQuestion.indexOf('Washing Machine Empties Into Septic') > -1 || selectedQuestion.indexOf('Condition of Lid') > -1 || selectedQuestion.indexOf('Aerator pump location') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'washing_machine_empties_into_septic' || el.questionReference == 'lid_condition' || el.questionReference == 'aerator_pump_location' || el.questionReference == 'condition_of_lid') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer != null && (selectedAnswer == 'Yes' || selectedAnswer == 'Sat' || selectedAnswer == 'Unknown' || selectedAnswer == 'Within tank' || selectedAnswer == 'Unknown/ Not Visible' || selectedAnswer == 'N/A')) {
          if(disable.greyWater.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer != null && (selectedAnswer == 'No' || selectedAnswer == 'Unsat' || selectedAnswer != 'Within tank')) {
          if(disable.greyWaterSystem.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.lidUnsatPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Total Number of Sewer Lines') > -1 || selectedQuestion.indexOf('How many modules are there') > -1 || selectedQuestion.indexOf('How many disposal beds serve the home') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'total_number_of_sewer_lines' || el.questionReference == 'total_number_of_sewer_lines1' || el.questionReference == 'total_number_of_sewer_lines2' || el.questionReference == 'how_many_modules_are_there' || el.questionReference == 'how_many_modules_are_there1' || el.questionReference == 'how_many_disposal_beds_serve_the_home' || el.questionReference == 'how_many_disposal_beds_serve_the_home1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer != null && selectedAnswer != '1') {
          if(disable.noOfSewerLine.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer != null && selectedAnswer == '1') {
          if(disable.noOfSewerLine.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('How Many Septic Systems Are Being Inspected') > -1 || selectedQuestion.indexOf('Interior of tank') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'how_many_septic_systems_are_being_inspected' || el.questionReference == 'interior_of_tank' || el.questionReference == 'interior_of_tank1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer != null && (selectedAnswer == "1" || selectedAnswer == 'Sat' || selectedAnswer == 'Unknown/ Not Visible' || selectedAnswer == 'Yes')) {
          if(disable.septicSystem.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer != null && (selectedAnswer != '1' || selectedAnswer == 'Unsat' || selectedAnswer == 'No')) {
          if(disable.septicSys.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.septicPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Shape of lid') > -1 || selectedQuestion.indexOf('Is there a grinder-ejector pump present') > -1 || selectedQuestion.indexOf('Shape of Cesspool') > -1 || selectedQuestion.indexOf('How does liquid spill over to lower trenches') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'lid_shape' || el.questionReference == 'shape_of_lid' || el.questionReference == 'shape_of_lid1' || el.questionReference == 'shape_of_lid1' || el.questionReference == 'shape_of_lid2' || el.questionReference == 'another_shape_of_lid' || el.questionReference == 'is_there_a_grinder_ejector_pump_present'
          || el.questionReference == 'shape_of_cesspool' || el.questionReference == 'how_does_liquid_spill_over_to_lower_trenches' || el.questionReference == 'how_does_liquid_spill_over_to_lower_trenches1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Round' || selectedAnswer == 'Yes' || selectedAnswer == 'D-box') {
          if(disable.round.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.dboxunsatPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          } else if(disable.roundDisable.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Coffin-Style' || selectedAnswer == 'No' || selectedAnswer == 'Unknown' || selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.coffinStyle.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Square' || selectedAnswer == 'Drop box') {
          if(disable.square.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.dropBox.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.dropBoxPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          }
        } else if (selectedAnswer == 'Rectangle' || selectedAnswer == 'Pipe connection') {
          if(disable.rectangle.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.pipeConn.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.pipeConnphoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Shape of lid') > -1 || selectedQuestion.indexOf('Signs or History of Sewage Backups in home') > -1 || selectedQuestion.indexOf('Condition of Effluent Filter') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'lid_shape' || el.questionReference == 'shape_of_lid' || el.questionReference == 'shape_of_lid' || el.questionReference == 'shape_of_lid1' || el.questionReference == 'shape_of_lid2' || el.questionReference == 'another_shape_of_lid' || el.questionReference == 'signs_or_history_of_sewage_backups_in_home'
          || el.questionReference == 'condition_of_effluent_filter') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Other' || selectedAnswer == 'Yes' || selectedAnswer == 'Unsat') {
          if(disable.lidDiameter.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.lidLength.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true; 
          } else if(disable.sewegeBackupPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false; 
          }
        } else if (selectedAnswer == 'No' || selectedAnswer == 'Unknown' || selectedAnswer == 'Sat' || selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.unknownSat.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Water Soften Present') > -1 || selectedQuestion.indexOf('D-box condition') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'water_soften_present' || el.questionReference == 'dbox_condition' || el.questionReference == 'D_box_condition' || el.questionReference == 'D_box_condition1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'No' || selectedAnswer == 'Sat' || selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.watersoftPre.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Yes' || selectedAnswer == 'Unsat') {
          if(disable.watersoftPreYes.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.dBoxPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Unknown') {
          if(disable.dboxOpening.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of Inlet baffle') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'condition_of_inlet_baffle') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Sat' || selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.watersoftPre.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Yes' || selectedAnswer == 'Unsat') {
          if(disable.watersoftPreYes.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of inlet baffle') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'condition_of_inlet_baffle1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Sat' || selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.doubleCompInletBaffle.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Unsat') {
          if(disable.doubleCompInletBaffle.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Models') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'models') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'H1000' || selectedAnswer == 'H1100' || selectedAnswer == 'H1200') {
          if(disable.hoot.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else {
          if(disable.hoot.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Shape of seepage pit') > -1 || selectedQuestion.indexOf('Manufacturer of Aerobic unit') > -1 || selectedQuestion.indexOf('Shape Of-D-Box') >-1 || selectedQuestion.indexOf('Last Precipitation') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'shape_of_seepage_pit' || el.questionReference == 'shape_of_seepage_pit1' || el.questionReference == 'shape_of_seepage_pit2' || el.questionReference == 'manufacturer_of_aerobic_unit' || el.questionReference == 'shape_of_dbox' || el.questionReference == 'last_precipitation') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Round' || selectedAnswer == 'Hoot' || selectedAnswer == 'none') {
          if(disable.diameterPit.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.squarePit.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Square' || selectedAnswer == 'Rectangle' || selectedAnswer == 'Rain' || selectedAnswer == 'Snow') {
          if(disable.volumeCalculator.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.daysIns.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          } else if(disable.diaPit.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else {
          if(disable.models.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of Outlet Baffle') > -1 || selectedQuestion.indexOf('Condition of discharge pipe') > -1 || selectedQuestion.indexOf('Drop box condition') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'condition_of_outlet_baffle' || el.questionReference == 'condition_of_outlet_baffle1' || selectedAnswer == 'cond_discharge_pipe' || el.questionReference == 'drop_box_condition' || el.questionReference == 'drop_box_condition1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unknown' || selectedAnswer == 'Sat' || selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.outSat.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Unsat') {
          if(disable.outUnsat.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.unsatPhotoDropBox.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of Outlet baffle') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'condition_of_outlet_baffle') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Sat' || selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.doubleCompOutBaffle.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Unsat') {
          if(disable.doubleCompOutBaffle.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of lateral pipe') > -1 || selectedQuestion.indexOf('Type of riser') >-1 || selectedQuestion.indexOf('Condition of outlet baffle') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'grease_trap_condition1' || el.questionReference == 'condition_of_lateral_pipe' || el.questionReference == 'condition_of_lateral_pipe1' || el.questionReference == 'pipe_connection1'
        || el.questionReference == 'type_of_riser' || el.questionReference == 'condition_of_outlet_baffle' || el.questionReference == 'condition_of_outlet_baffle1') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Sat' || selectedAnswer == 'Round' || selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.lateralPipe.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } 
          if(disable.riserdiameter.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
          if(disable.doubleCompOutBaffle.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Unsat' || selectedAnswer == 'Square') {
          if(disable.greaseUnsat.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } 
          if(disable.unsatPipePhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
          } 
          if(disable.unknownReason.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
          if(disable.doubleCompOutBaffle.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          }
        } else if (selectedAnswer == 'Unknown' || selectedAnswer == 'Other') {
          if(disable.unknown1.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.riserSquare.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Bed Location, Relating to home') > -1 || selectedQuestion.indexOf('Location, relating to the home') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'bed_location_relating_to_home' || el.questionReference == 'bed_location_relating_to_home1' || el.questionReference == 'location_relating_to_the_home') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer != 'Unknown') {
          if(disable.bedLocation.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.disposalTrenchLocationPhoto.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Unknown') {
          if(disable.bedLocation.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.disposalTrenchLocationPhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Grease Trap condition') > -1 || selectedQuestion.indexOf('Pipe Connection') > -1 ) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'grease_trap_condition' || el.questionReference == 'pipe_connection' ) {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Sat' || selectedAnswer == 'Unknown') {
          if(disable.greaseTrapUnknown.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Unsat') {
          if(disable.greaseTrapUnsat.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.greaseTrapUnknownReason.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          } else if(disable.pipePhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = false;
          }
        } else if (selectedAnswer == 'Unknown/ Not Visible') {
          if(disable.pipePhoto.includes(el.questionReference)) {
            el.disableFlag = false;
            el.hideElement = true;
            el.mandatory = true;
          } else if(disable.reasonForUnsat.includes(el.questionReference)) {
            el.disableFlag = true;
            el.hideElement = false;
            el.mandatory = false;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(!event?.mobileView) {
    this.originalQuestionUpdate(event.detail.value, index);
    }
  } 

  OnChangeDropdown = (event: any, id: number, index: number, pNo: number) => {
    //To display questions based on dropdown value choosen
    const sequenceNumber = this.state.originalQuestion.headerTO.sequenceNumber;
    const moduleInspected = this.state.inspectionDetailsTO.moduleInspected;
    const direction = "forward";
    let val = event.detail.value;
    console.log("dropdown value", val);
    if(val == 'Complete Inspection') {
      val = 'Notes';
    }
    const number = this.state.inspectionDetailsTO.moduleNumber;
    // const moduleNumber = "module" + parseInt(number.split('module')[1] + 1);
    let result = number.split('module');
    let res = parseInt(result[1]) + 1;
    const moduleNumber = "module" + res;
    const typeFromBackEnd = this.state.inspectionDetailsTO.typeFromBackEnd;
    const lastPage = this.state.inspectionDetailsTO.lastPage;
    console.log("=====", lastPage);

    let url = "";
    if (val != 'Cancel') {
      url = apiConstants.inspectionquestions + id + '&page=1' + '&currentModule=' + val + '&moduleNumber=' + moduleNumber + '&typeFromBackEnd=' + typeFromBackEnd+ '&typeFromUI=' + val + '&direction=' + direction + '&sequenceNumber=' + sequenceNumber + '&user=' + localStorage.username;
    } else if (val == 'Cancel') {
      url = apiConstants.inspectionquestions + id + '&page=1' + '&currentModule=' + val + '&moduleNumber=' + number + '&sequenceNumber=' + sequenceNumber + '&user=' + localStorage.username;
    }

    this.navigationApiCall(url);

    this.originalQuestionUpdate(event.detail.value, index);
    if(val != null && val == 'Interior Plumbing') {
      this.updateInspection();
    }
  }


  onChangeMultiDropDown = (event: any, index: number) => {
    const val = event.detail.value;
    // const finval = val.toString();
    const finval = (val as string[]).join(', ');
    // this.disableMandatoryFlag();
    const updatedData = { ...this.state.data };
    if (updatedData && updatedData.length &&
      updatedData.length > index && updatedData[index].answer) {
      updatedData[index].answer = event;

      this.setState({
        data: updatedData
      })
      console.log(event);
    }
    this.originalQuestionUpdate(finval, index);
  }

  rangeUpdate = (event: any, index: number) => {

    //To update range values
    const updatedData = { ...this.state };
    // this.disableMandatoryFlag();
    let selectedQuestion = updatedData.data[index].mobileView;
    let selectedAnswer = updatedData.data[index].answer;
    if (event?.mobileView) {
      selectedQuestion = event.mobileView;
      selectedAnswer = event.answer;
    }
    if (updatedData && updatedData.data && updatedData.data.length &&
      updatedData.data.length > index && updatedData.data[index].answer) {
      if(!event?.mobileView) {
        updatedData.data[index].answer = (!isNaN(Number(event)) ? event : '0');
      }
      // updatedData.data[index].answer = (!isNaN(Number(event)) ? event : '0');

      if ((this.currentPageNumber == 3 && updatedData.inspectionDetailsTO.currentModule == '1 Compartment') ||
        (this.currentPageNumber == 4 && updatedData.inspectionDetailsTO.currentModule == '2 Compartment') ||
        (this.currentPageNumber == 2 && updatedData.inspectionDetailsTO.currentModule == 'Grease Trap')) {

          if(updatedData.data[index].questionReference == 'liquid_removed_as_per_pumper') {
            if (updatedData.data[index - 3].answer == 'Yes' && updatedData.data[index].answer == updatedData.data[index - 1].answer) {
              updatedData.data[index + 1].disableFlag = true;
              updatedData.data[index + 1].mandatory = false;
              updatedData.data[index + 2].disableFlag = true;
              updatedData.data[index + 2].mandatory = false;
              updatedData.data[index + 3].disableFlag = true;
              updatedData.data[index + 3].mandatory = false;
              updatedData.data[index + 4].disableFlag = true;
              updatedData.data[index + 4].mandatory = false;
              updatedData.data[index + 5].disableFlag = true;
              updatedData.data[index + 5].mandatory = false;
              updatedData.data[index + 6].disableFlag = true;
              updatedData.data[index + 6].mandatory = false;
              updatedData.data[index + 7].disableFlag = true;
              updatedData.data[index + 7].mandatory = false;
              updatedData.data[index + 8].disableFlag = true;
              updatedData.data[index + 8].mandatory = false;
              updatedData.data[index + 9].disableFlag = true;
              updatedData.data[index + 9].mandatory = false;
            }
            if (updatedData.data[index - 3].answer == 'Yes' && updatedData.data[index].answer != updatedData.data[index - 1].answer) {
              updatedData.data[index + 1].disableFlag = false;
              updatedData.data[index + 1].mandatory = true;
              updatedData.data[index + 2].disableFlag = false;
              updatedData.data[index + 2].mandatory = true;
              updatedData.data[index + 3].disableFlag = false;
              updatedData.data[index + 3].mandatory = true;
              updatedData.data[index + 4].disableFlag = false;
              updatedData.data[index + 4].mandatory = true;
              updatedData.data[index + 5].disableFlag = false;
              updatedData.data[index + 5].mandatory = true;
              updatedData.data[index + 6].disableFlag = false;
              updatedData.data[index + 6].mandatory = true;
              updatedData.data[index + 7].disableFlag = false;
              updatedData.data[index + 7].mandatory = true;
              updatedData.data[index + 8].disableFlag = false;
              updatedData.data[index + 8].mandatory = true;
              updatedData.data[index + 9].disableFlag = false;
              updatedData.data[index + 9].mandatory = true;
            }
        }

          if(updatedData.data[index].questionReference == 'volume_of_liquid_removed_as_per_pumper') {
            if (updatedData.data[index - 3].answer == 'Yes' &&  updatedData.data[index].answer == updatedData.data[index - 1].answer) {
              updatedData.data[index + 1].disableFlag = true;
              updatedData.data[index + 1].mandatory = false;
              updatedData.data[index + 2].disableFlag = true;
              updatedData.data[index + 2].mandatory = false;
              updatedData.data[index + 3].disableFlag = true;
              updatedData.data[index + 3].mandatory = false;
              updatedData.data[index + 4].disableFlag = true;
              updatedData.data[index + 4].mandatory = false;
              updatedData.data[index + 5].disableFlag = true;
              updatedData.data[index + 5].mandatory = false;
              updatedData.data[index + 6].disableFlag = true;
              updatedData.data[index + 6].mandatory = false;
              updatedData.data[index + 7].disableFlag = true;
              updatedData.data[index + 7].mandatory = false;
              updatedData.data[index + 8].disableFlag = true;
              updatedData.data[index + 8].mandatory = false;
              updatedData.data[index + 9].disableFlag = true;
              updatedData.data[index + 9].mandatory = false;
              updatedData.data[index + 10].disableFlag = true;
              updatedData.data[index + 10].mandatory = false;
            }
            if (updatedData.data[index - 3].answer == 'Yes' && updatedData.data[index].answer != updatedData.data[index - 1].answer) {
              updatedData.data[index + 1].disableFlag = false;
              updatedData.data[index + 1].mandatory = true;
              updatedData.data[index + 2].disableFlag = false;
              updatedData.data[index + 2].mandatory = true;
              updatedData.data[index + 3].disableFlag = false;
              updatedData.data[index + 3].mandatory = true;
              updatedData.data[index + 4].disableFlag = false;
              updatedData.data[index + 4].mandatory = true;
              updatedData.data[index + 5].disableFlag = false;
              updatedData.data[index + 5].mandatory = true;
              updatedData.data[index + 6].disableFlag = false;
              updatedData.data[index + 6].mandatory = true;
              updatedData.data[index + 7].disableFlag = false;
              updatedData.data[index + 7].mandatory = true;
              updatedData.data[index + 8].disableFlag = false;
              updatedData.data[index + 8].mandatory = true;
              updatedData.data[index + 9].disableFlag = false;
              updatedData.data[index + 9].mandatory = true;
              updatedData.data[index + 10].disableFlag = false;
              updatedData.data[index + 10].mandatory = true;
            }
          }
      }
      //Disposal Bed & Trenches Logics
      if(updatedData.inspectionDetailsTO.currentModule == 'Disposal Bed' || updatedData.inspectionDetailsTO.currentModule == 'Disposal Trenches'
        || updatedData.inspectionDetailsTO.currentModule == 'Serial Trench Lateral' || updatedData.inspectionDetailsTO.currentModule == 'Pressure Dosed Bed') {
        if(updatedData.data[index].mobileView == 'Depth to bottom of gravel') {
          let labelAnswer =  updatedData.data[index].answer -  updatedData.data[index - 1].answer;
          updatedData.data[index + 1].answer = labelAnswer;
        }
        if(updatedData.data[index].mobileView == 'Depth of gravel above lateral including lateral pipe') {
          let labelAnswer =  updatedData.data[index - 1].answer -  updatedData.data[index].answer;
          updatedData.data[index + 1].answer = labelAnswer;
          console.log("labelAnswer", labelAnswer);
        }
      }
      //Disposal Bed & Trenches Logics
      if(updatedData.inspectionDetailsTO.currentModule == 'Disposal Bed' || updatedData.inspectionDetailsTO.currentModule == 'Pressure Dosed Bed' || updatedData.inspectionDetailsTO.currentModule == 'Disposal Trenches' || updatedData.inspectionDetailsTO.currentModule == 'Serial Trench Lateral') {

        if(updatedData.data[index].mobileView == 'Depth of standing water') {
          let labelAnswer =  updatedData.data[index - 2].answer -  updatedData.data[index].answer;
          updatedData.data[index + 1].answer = labelAnswer;
          console.log("labelAnswer", labelAnswer);
          if(labelAnswer <= 6) {
          updatedData.data[index + 2].answer = "Yes"; 
          updatedData.data[index + 3].answer = labelAnswer; 
          updatedData.data[index + 3].disableFlag = false;
          } else {
          updatedData.data[index + 2].answer = "No"; 
          updatedData.data[index + 3].answer = ""; 
          updatedData.data[index + 3].disableFlag = true;
          }
        }
      }
    }
    if (event?.mobileView) {
      this.rangeQuestionUpdate(event.answer, index);
    }

    if(!event?.mobileView) {
      this.rangeQuestionUpdate(event, index);
      }

  }

  sequenceNumberUpdate = (event: any, index: number) => {
    const updatedData = { ...this.state.originalQuestion }
    if (updatedData && updatedData.inspectionQuestionTOs.length > index && updatedData.inspectionQuestionTOs[index]) {
      updatedData.inspectionQuestionTOs[index].answer = event;
      if (event != null && event == 'Yes') {
        updatedData.headerTO.sequenceNumber = updatedData.headerTO.sequenceNumber + 1;
      } else if (event != null && event == 'No') {
        // updatedData.headerTO.sequenceNumber = updatedData.headerTO.sequenceNumber;
        updatedData.headerTO.sequenceNumber = 1;
      }
      this.setState({
        originalQuestion: updatedData,
      });
    }
  }

  submitInspection = (id: number) => {
    Swal.fire({
      title: 'Are you sure you want to submit?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'Submit',
      denyButtonText: `Don't Submit`,
      preConfirm: () => {
        const name = localStorage.username;
        const submit = apiConstants.submitInspection + id + '/' + name;
        API.authGetRequest(submit, '')
          .then((res) => {
            const responseData = res.data;
            if (responseData.message == 'Inspection Completed') {
              Swal.fire('Success!', responseData.message, 'success')
              this.props.history.push('/upcoming-schedule?selection=inspectionschedule')
              this.uploadPresentation(this.selectedData.id);
              return true;
            }
          }).catch((err) => {
            Swal.fire('Changes are not saved', '', 'info')
            console.log("error =>", err)
          })

        return false;

      }

    });

    this.updateInspection();
  }

  uploadPresentation = (id: number) => {
    const uploadPresentation = apiConstants.uploadPresentation + id;
    API.authGetRequest(uploadPresentation, '')
      .then((res) => {
        const responseData = res.data;
        console.log(responseData);
      }).catch((err) => {
        console.log("error =>", err)
      })
  }


  ionViewWillEnter() {
    console.log('ionViewWillEnter event fired')
  }

  ionViewWillLeave() {
    console.log('ionViewWillLeave event fired')
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter event fired')
  }

  ionViewDidLeave() {
    console.log('ionViewDidLeave event fired')
  }

  async takePhoto(index: number) {

    const formdata = CAMERA();
    this.uploadImage(await formdata, this.selectedData.id, index);
  }

  // Upload Captured Image
  uploadImage(formData: FormData, id: number, index: number) {
    const customerId = this.props.location.state.userData.customerId;
    const townshipId = this.props.location.state.userData.townshipId;
    const compartmentType = this.state.data[index].compartmentType;
    const questionReference = this.state.data[index].questionReference;
    const moduleNumber = this.state.inspectionDetailsTO.moduleNumber;
    const moduleId = this.state.headerTO.moduleId;
    const sequenceNumber = this.state.inspectionDetailsTO.sequenceNumber;
    const type = "inspection";
    const uploadRequest = API.authPostRequest(apiConstants.photoUploadUrl + id + '&type=' + type + '&customerId=' +
      + customerId + '&townshipId=' + townshipId + '&compartment=' + compartmentType + '&questionReference=' + questionReference
      + '&moduleNumber=' + moduleNumber + '&moduleId=' + moduleId + '&sequenceNumber=' + sequenceNumber, formData);
    uploadRequest
      .then(async () => {
        console.log('ImageUploaded Successfully');
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Convert base64 to blob
  base64ToImage(dataURI: String) {
    const fileDate = dataURI.split(',');
    const byteString = atob(fileDate[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: 'image/png' });
    return blob;
  }
render() {
    const { name } = this.state;
    const { key } = this.state;
    return (
      <InsPage>
        <IonPage key = {key}>
          <IonHeader>
            <IonToolbar>
              <IonRow>
                <IonCol size="4" >
                  <IonItem lines="none" onClick={this.goBack} >
                    <IonIcon color="primary" slot="start" icon={chevronBackSharp} style={{ fontSize: "40px", paddingTop: "10px" }} />
                  </IonItem>
                </IonCol>
                <IonCol className="ion-align-self-center" style={{ textAlign: "justify" }}>
                  <img src="assets/logo001.png" width="40%" />
                </IonCol>
                <LogoutPage />

              </IonRow>
            </IonToolbar>
            <IonToolbar color="secondary">

              <IonTitle>Powered By:<span><b>Septic Smart</b></span></IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent fullscreen>

            <IonCard style={{ borderTop: "4px solid #53A658" }}>
              <IonCardHeader>
                <div style={{ textAlign: "center" }}>
                <IonTitle className="iontitle"><b>{this.state?.headerTO?.title}</b> </IonTitle>
                </div>
                <div style={{textAlign: "right"}}>
                <em style = {{color : 'red'}}>*</em><em className = "mandatory"> indicates mandatory field</em>
                </div>
              </IonCardHeader>

              {(this.state.data.map((user: any, index: number) => (
                <IonCardContent key={index} className="card_content">
                  {(user.answerType == 'textxf' || user.answerType == 'calculate') ?
                    <IonRow>
                      <IonCol>
                        <IonItem disabled = {user.disableFlag}>
                          {(() => {
                            if (user.answerType == 'textStatic') {
                              return (
                                <><IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> </IonLabel><IonLabel style={{ color: "#019849", fontWeight: "bold", textAlign : "end" }}> {localStorage.username} </IonLabel></>
                              )
                            } 
                            if (user.answerType == 'calculate' && user.questionReference == 'how_close_to_laterals') {
                              return (
                                <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; <IonBadge>{this.state.data[index - 2].answer != null ? this.state.data[index - 2].answer + '"' : '0"'}</IonBadge></IonLabel>
                              ) 
                            } 
                            if (user.answerType == 'calculate' && user.questionReference == 'how_close_to_lateral') {
                              return (
                                <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; <IonBadge>{this.state.data[index - 2].answer != null ? this.state.data[index - 2].answer + '"' : '0"'}</IonBadge></IonLabel>
                              ) 
                            } 
                            if (user.answerType == 'calculate' && user.questionReference == 'total_thickness_of_gravel') {
                              return (
                                <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp;  <IonBadge>{this.state.data[index - 1].answer - this.state.data[index - 2].answer + '"'}</IonBadge></IonLabel>
                              ) 
                            } else if (user.answerType == 'calculate' && user.questionReference == 'depth_of_gravel_below_lateral') {
                              return (
                                <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; <IonBadge>{this.state.data[index - 2].answer - this.state.data[index - 1].answer + '"'}</IonBadge></IonLabel>
                              ) 
                            } else if (user.answerType == 'calculate' && user.questionReference == 'thickness_of_dry_stone' && (user.compartmentType == 'Disposal Bed' || user.compartmentType == 'Pressure Dosed Bed' || user.compartmentType == 'Disposal Trenches' || user.compartmentType == 'Serial Trench Lateral')) {
                              return (
                                <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; <IonBadge>{this.state.data[index - 3].answer - this.state.data[index - 1].answer + '"'}</IonBadge></IonLabel>
                              ) 
                            } 
                          })()}
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'text') ?
                    <IonRow>
                      <IonCol>
                      {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                        <IonItem disabled={user.disableFlag}>
                          <><IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b> </IonLabel> <IonLabel style={{ color: "#019849", fontWeight: "bold", textAlign: "end" }}> {user.answer} </IonLabel></>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'calculateValues') ?
                    <IonRow>
                      <IonCol>
                        <form>
                          <IonItem disabled = {user.disableFlag}>
                          {(() => {
                            if (this.state.originalQuestion.inspectionQuestionTOs[index - 6].answer == 'Round' && this.state.data[index].compartmentType != 'Seepage Pit') {
                              let diameter = this.state.data[index - 4].answer - 6;
                              let radius = diameter/2;
                              let height = this.state.data[index - 3].answer;
                              let labelAnswer = (3.14159 * radius * radius * height) / 231;
                              let roundOff = Math.round(labelAnswer);
                              if(roundOff >= 900 && roundOff <= 1160) {
                                roundOff = 1000;
                              } else if(roundOff >1160 && roundOff <=1270) {
                                roundOff = 1250;
                              } else if(roundOff >1270 && roundOff <=1400) {
                                roundOff = 1300;
                              } else if(roundOff >1400 && roundOff <=1625) {
                                roundOff = 1500;
                              } else if(roundOff >1625 && roundOff <= 1875) {
                                roundOff = 1750;
                              } else if(roundOff >1875) {
                                roundOff = 2000;
                              }
                              return (
                                <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; <IonBadge>{roundOff + ' gal'}</IonBadge></IonLabel>
                              ) 
                            }
                            if (this.state.originalQuestion.inspectionQuestionTOs[index - 6].answer == 'Round' && this.state.data[index].compartmentType == 'Seepage Pit') {
                              let diameter = this.state.data[index - 5].answer - 6;
                              let radius = diameter/2;
                              let height = this.state.data[index - 4].answer;
                              let labelAnswer = (3.14159 * radius * radius * height) / 231;
                              let roundOff = Math.round(labelAnswer);
                              if(roundOff >= 900 && roundOff <= 1160) {
                                roundOff = 1000;
                              } else if(roundOff >1160 && roundOff <=1270) {
                                roundOff = 1250;
                              } else if(roundOff >1270 && roundOff <=1400) {
                                roundOff = 1300;
                              } else if(roundOff >1400 && roundOff <=1625) {
                                roundOff = 1500;
                              } else if(roundOff >1625 && roundOff <= 1875) {
                                roundOff = 1750;
                              } else if(roundOff >1875) {
                                roundOff = 2000;
                              }
                              return (
                                <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; <IonBadge>{roundOff + ' gal'}</IonBadge></IonLabel>
                              ) 
                            }
                            if (this.state.originalQuestion.inspectionQuestionTOs[index - 6].answer == 'Rectangle' && this.state.data[index].compartmentType != 'Seepage Pit') {
                              let length = null;
                              if(this.state.originalQuestion.inspectionQuestionTOs[index - 5].answer == 'Yes') {
                                length = this.state.data[index - 2].answer - 9;
                              } else {
                                length = this.state.data[index - 2].answer - 6;
                              }
                              let breadth = this.state.data[index - 1].answer - 6;
                              let height = this.state.data[index - 3].answer;
                              let labelAnswer = (length * breadth * height) / 231;
                              let roundOff = Math.round(labelAnswer);
                              if(roundOff >= 900 && roundOff <= 1160) {
                                roundOff = 1000;
                              } else if(roundOff >1160 && roundOff <=1270) {
                                roundOff = 1250;
                              } else if(roundOff >1270 && roundOff <=1400) {
                                roundOff = 1300;
                              } else if(roundOff >1400 && roundOff <=1625) {
                                roundOff = 1500;
                              } else if(roundOff >1625 && roundOff <= 1875) {
                                roundOff = 1750;
                              } else if(roundOff >1875) {
                                roundOff = 2000;
                              }
                              return (
                                <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; <IonBadge>{roundOff + ' gal'}</IonBadge></IonLabel>
                              ) 
                            }
                            if (this.state.originalQuestion.inspectionQuestionTOs[index - 6].answer == 'Square' && this.state.data[index].compartmentType == 'Seepage Pit') {
                              let length = this.state.data[index - 2].answer - 6;
                              let breadth = this.state.data[index - 1].answer - 6;
                              let height = this.state.data[index - 4].answer;
                              let labelAnswer = (length * breadth * height) / 231;
                              let roundOff = Math.round(labelAnswer);
                              if(roundOff >= 900 && roundOff <= 1160) {
                                roundOff = 1000;
                              } else if(roundOff >1160 && roundOff <=1270) {
                                roundOff = 1250;
                              } else if(roundOff >1270 && roundOff <=1400) {
                                roundOff = 1300;
                              } else if(roundOff >1400 && roundOff <=1625) {
                                roundOff = 1500;
                              } else if(roundOff >1625 && roundOff <= 1875) {
                                roundOff = 1750;
                              } else if(roundOff >1875) {
                                roundOff = 2000;
                              }
                              return (
                                <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; <IonBadge>{roundOff + ' gal'}</IonBadge></IonLabel>
                              ) 
                            }
                          })()}
                          </IonItem>
                        </form>
                      </IonCol>
                    </IonRow>
                    : null}

                    {(user.answerType === 'tankCalculate') ?
                    <IonRow>
                      <IonCol>
                        <form>
                          <IonItem disabled = {user.disableFlag}>
                          {(() => {
                            if (this.state.originalQuestion.inspectionQuestionTOs[index - 7].answer == 'Round' && this.state.data[index].compartmentType != 'Grease Trap') {
                              let diameter = this.state.data[index - 5].answer - 6;
                              let radius = diameter/2;
                              let height = this.state.data[index - 4].answer;
                              let labelAnswer = (3.14159 * radius * radius * height) / 231;
                              let roundOff = Math.round(labelAnswer);
                              if(roundOff >= 900 && roundOff <= 1160) {
                                roundOff = 1000;
                              } else if(roundOff >1160 && roundOff <=1270) {
                                roundOff = 1250;
                              } else if(roundOff >1270 && roundOff <=1400) {
                                roundOff = 1300;
                              } else if(roundOff >1400 && roundOff <=1625) {
                                roundOff = 1500;
                              } else if(roundOff >1625 && roundOff <= 1875) {
                                roundOff = 1750;
                              } else if(roundOff >1875) {
                                roundOff = 2000;
                              }
                              let tankVolume;
                              if (this.state.originalQuestion.inspectionQuestionTOs[index - 10].answer != this.state.originalQuestion.inspectionQuestionTOs[index - 9].answer) {
                                let assumedVolume = this.state.data[index - 10].answer;
                                let calculatedVolume = roundOff;
                              if(calculatedVolume != null && assumedVolume != null && (calculatedVolume >= assumedVolume)) {
                                  tankVolume = "No";
                              } else if (calculatedVolume != null && assumedVolume != null && (calculatedVolume < assumedVolume)) {
                                  tankVolume = "Yes";
                              }
                              this.state.data[index].answer = tankVolume
                            } else {
                              tankVolume = "";
                            }
                              return (
                                <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; {tankVolume}</IonLabel>
                              ) 
                            }
                            if (this.state.originalQuestion.inspectionQuestionTOs[index - 7].answer == 'Round' && this.state.data[index].compartmentType == 'Grease Trap') {
                              let diameter = this.state.data[index - 5].answer - 6;
                              let radius = diameter/2;
                              let height = this.state.data[index - 4].answer;
                              let labelAnswer = (3.14159 * radius * radius * height) / 231;
                              let roundOff = Math.round(labelAnswer);
                              if(roundOff >= 900 && roundOff <= 1160) {
                                roundOff = 1000;
                              } else if(roundOff >1160 && roundOff <=1270) {
                                roundOff = 1250;
                              } else if(roundOff >1270 && roundOff <=1400) {
                                roundOff = 1300;
                              } else if(roundOff >1400 && roundOff <=1625) {
                                roundOff = 1500;
                              } else if(roundOff >1625 && roundOff <= 1875) {
                                roundOff = 1750;
                              } else if(roundOff >1875) {
                                roundOff = 2000;
                              }
                              let tankVolume;
                              if (this.state.originalQuestion.inspectionQuestionTOs[index - 10].answer != this.state.originalQuestion.inspectionQuestionTOs[index - 11].answer) {
                                let assumedVolume = this.state.data[index - 11].answer;
                                let calculatedVolume = roundOff;
                              if(calculatedVolume != null && assumedVolume != null && (calculatedVolume >= assumedVolume)) {
                                  tankVolume = "No";
                              } else if (calculatedVolume != null && assumedVolume != null && (calculatedVolume < assumedVolume)) {
                                  tankVolume = "Yes";
                              }
                              this.state.data[index].answer = tankVolume
                            } else {
                              tankVolume = "";
                            }
                              return (
                                <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; {tankVolume}</IonLabel>
                              ) 
                            }
                            if (this.state.originalQuestion.inspectionQuestionTOs[index - 7].answer == 'Rectangle' && this.state.data[index].compartmentType != 'Grease Trap') {
                              let length = null;
                              if(this.state.originalQuestion.inspectionQuestionTOs[index - 6].answer == 'Yes') {
                                length = this.state.data[index - 3].answer - 9;
                              } else {
                                length = this.state.data[index - 3].answer - 6;
                              }
                              let breadth = this.state.data[index - 2].answer - 6;
                              let height = this.state.data[index - 4].answer;
                              let labelAnswer = (length * breadth * height) / 231;
                              let roundOff = Math.round(labelAnswer);
                              if(roundOff >= 900 && roundOff <= 1160) {
                                roundOff = 1000;
                              } else if(roundOff >1160 && roundOff <=1270) {
                                roundOff = 1250;
                              } else if(roundOff >1270 && roundOff <=1400) {
                                roundOff = 1300;
                              } else if(roundOff >1400 && roundOff <=1625) {
                                roundOff = 1500;
                              } else if(roundOff >1625 && roundOff <= 1875) {
                                roundOff = 1750;
                              } else if(roundOff >1875) {
                                roundOff = 2000;
                              }
                              let tankVolume;
                              if (this.state.originalQuestion.inspectionQuestionTOs[index - 10].answer != this.state.originalQuestion.inspectionQuestionTOs[index - 9].answer) {
                                let assumedVolume = this.state.data[index - 10].answer;
                                let calculatedVolume = roundOff;
                              if(calculatedVolume != null && assumedVolume != null && (calculatedVolume >= assumedVolume)) {
                                  tankVolume = "No";
                              } else if (calculatedVolume != null && assumedVolume != null && (calculatedVolume < assumedVolume)) {
                                  tankVolume = "Yes";
                              }
                              this.state.data[index].answer = tankVolume
                            } else {
                              tankVolume = "";
                            }
                              return (
                                <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; {tankVolume}</IonLabel>
                              ) 
                            }
                            if (this.state.originalQuestion.inspectionQuestionTOs[index - 7].answer == 'Rectangle' && this.state.data[index].compartmentType == 'Grease Trap') {
                              let length = this.state.data[index - 3].answer - 6;
                              let breadth = this.state.data[index - 2].answer - 6;
                              let height = this.state.data[index - 4].answer;
                              let labelAnswer = (length * breadth * height) / 231;
                              let roundOff = Math.round(labelAnswer);
                              if(roundOff >= 900 && roundOff <= 1160) {
                                roundOff = 1000;
                              } else if(roundOff >1160 && roundOff <=1270) {
                                roundOff = 1250;
                              } else if(roundOff >1270 && roundOff <=1400) {
                                roundOff = 1300;
                              } else if(roundOff >1400 && roundOff <=1625) {
                                roundOff = 1500;
                              } else if(roundOff >1625 && roundOff <= 1875) {
                                roundOff = 1750;
                              } else if(roundOff >1875) {
                                roundOff = 2000;
                              }
                              let tankVolume;
                              if (this.state.originalQuestion.inspectionQuestionTOs[index - 10].answer != this.state.originalQuestion.inspectionQuestionTOs[index - 11].answer) {
                                let assumedVolume = this.state.data[index - 11].answer;
                                let calculatedVolume = roundOff;
                              if(calculatedVolume != null && assumedVolume != null && (calculatedVolume >= assumedVolume)) {
                                  tankVolume = "No";
                              } else if (calculatedVolume != null && assumedVolume != null && (calculatedVolume < assumedVolume)) {
                                  tankVolume = "Yes";
                              }
                              this.state.data[index].answer = tankVolume
                            } else {
                              tankVolume = "";
                            }
                              return (
                                <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; {tankVolume}</IonLabel>
                              ) 
                            }
                          })()}
                          </IonItem>
                        </form>
                      </IonCol>
                    </IonRow>
                    : null} 

                  {(user.answerType === 'waterVolume' && user.questionReference == 'water_volume_calculator') ?
                    <IonRow>
                      <IonCol>
                        <form>
                          <IonItem disabled={user.disableFlag}>
                            {(() => {
                              if (this.state.originalQuestion.inspectionQuestionTOs[index - 7].answer == 'Round' && this.state.data[index].compartmentType == 'Seepage Pit') {
                                let diameter = this.state.data[index - 6].answer - 6;
                                let radius = diameter / 2;
                                let height = this.state.data[index - 4].answer;
                                let labelAnswer = (3.14159 * radius * radius * height) / 231;
                                let roundOff = Math.round(labelAnswer);
                                if (roundOff >= 900 && roundOff <= 1160) {
                                  roundOff = 1000;
                                } else if (roundOff > 1160 && roundOff <= 1270) {
                                  roundOff = 1250;
                                } else if (roundOff > 1270 && roundOff <= 1400) {
                                  roundOff = 1300;
                                } else if (roundOff > 1400 && roundOff <= 1625) {
                                  roundOff = 1500;
                                } else if (roundOff > 1625 && roundOff <= 1875) {
                                  roundOff = 1750;
                                } else if (roundOff > 1875) {
                                  roundOff = 2000;
                                }
                                return (
                                  <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; <IonBadge>{roundOff + ' gal'}</IonBadge></IonLabel>
                                )
                              }
                              if (this.state.originalQuestion.inspectionQuestionTOs[index - 7].answer == 'Square' && this.state.data[index].compartmentType == 'Seepage Pit') {
                                let length = this.state.data[index - 3].answer - 6;
                                let breadth = this.state.data[index - 2].answer - 6;
                                let height = this.state.data[index - 4].answer;
                                let labelAnswer = (length * breadth * height) / 231;
                                let roundOff = Math.round(labelAnswer);
                                if (roundOff >= 900 && roundOff <= 1160) {
                                  roundOff = 1000;
                                } else if (roundOff > 1160 && roundOff <= 1270) {
                                  roundOff = 1250;
                                } else if (roundOff > 1270 && roundOff <= 1400) {
                                  roundOff = 1300;
                                } else if (roundOff > 1400 && roundOff <= 1625) {
                                  roundOff = 1500;
                                } else if (roundOff > 1625 && roundOff <= 1875) {
                                  roundOff = 1750;
                                } else if (roundOff > 1875) {
                                  roundOff = 2000;
                                }
                                return (
                                  <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; <IonBadge>{roundOff + ' gal'}</IonBadge></IonLabel>
                                )
                              }
                            })()}
                          </IonItem>
                        </form>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'waterVolume' && user.questionReference == 'empty_space') ?
                    <IonRow>
                      <IonCol>
                        <form>
                          <IonItem disabled={user.disableFlag}>
                          <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; <IonBadge>{this.state.data[index - 2].answer - this.state.data[index - 1].answer}</IonBadge></IonLabel>
                          </IonItem>
                        </form>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'Note') ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; No </IonLabel>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'textChange') ?
                    <IonRow>
                      <IonCol>
                      {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                        <form>
                          <IonItem>
                            <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView}{user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null} </b></IonLabel>
                            <IonInput className="ion-text-wrap"  style={{ color: "#019849", fontWeight: "bold" }} onKeyPress={this.handleKeyPress} value={user.answer} disabled={user.disableFlag} onIonChange={e => { this.textOnChange(e.detail.value, index) }}></IonInput>
                          </IonItem>
                        </form>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'photo') ?
                    <IonRow>
                      <IonCol>
                        <IonItem disabled={user.disableFlag}>
                          <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b></IonLabel>
                          <IonFab horizontal="end">
                            <IonFabButton disabled={user.disableFlag}>
                              <IonIcon style={{ fontSize: "w3-tiny" }} icon={camera} onClick={() => this.takePhoto(index)} />
                            </IonFabButton>
                          </IonFab>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'date' && user.answer != null) ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b>{moment(user.answer).format('MM/DD/YY')} </IonLabel>
                          {/* <IonInput value={moment(user.answer).format('MM/DD/YYYY')}></IonInput> */}
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'date' && user.answer === null) ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <IonLabel className="ion-text-wrap"> <b>{user.questionNumber} {user.mobileView} </b> &nbsp; N/A</IonLabel>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'Select Date') ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <IonLabel> <b>{user.questionNumber} {user.mobileView} </b> </IonLabel>
                          <IonDatetime className='text-color' value={moment(user.answer).format('YYYY-MM-DD')} placeholder="Select date" disabled={user.disableFlag} onIonChange={e => { this.textOnChange(e.detail.value, index) }}></IonDatetime>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}


                  {(user.answerType === 'Main Heading') ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <IonLabel className="iontitle"><b>{user.mobileView}</b></IonLabel>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType == 'textarea') ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <label style={{ color: '#000000' }}> <b>{user.questionNumber} {user.mobileView}</b></label>
                          <textarea className="text-wrap" value={user.answer} style={{ marginLeft: '10%', display: 'flex', width: "50%", height: "100px" }} placeholder="Please Type Here..." onChange={e => { this.textOnChange(e.target.value, index) }}></textarea>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType == 'audio') ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <label style={{ color: '#000000' }}> <b>{user.questionNumber} {user.mobileView}</b> &nbsp;</label>
                          <AudioRecoder parentCallback={this.handleCallback} />
                          {name}
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'radio' || user.answerType == 'radio wrap') ?
                    <IonRow>
                      <IonCol>
                      {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN' || user.answer == 0)) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                        <IonItem disabled={user.disableFlag}>
                          <IonRadioGroup className="app-font" style={{ display: "flex" }} value={user.answer} onIonChange={e => { this.radioOnchange(e, index) }}>
                            {(() => {
                              if (user.answerType == 'radio') {
                                return (
                                  <IonLabel className="app-font" ><b>{user.questionNumber} {user.mobileView}{user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b></IonLabel>
                                )
                              } else if (user.answerType == 'radio wrap') {
                                return (
                                  <IonLabel className="ion-text-wrap" ><b>{user.questionNumber} {user.mobileView}{user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b></IonLabel>
                                )
                              }
                            })()}
                            {user.answerValue.split(',').map((el: string, k: number) => (
                              <IonItem key={k} className="ion-item-top-adjust">
                                <IonLabel className='text-color'>{el}</IonLabel>
                                <IonRadio slot="start" value={el} disabled={user.disableFlag} />
                              </IonItem>))}                              
                          </IonRadioGroup>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'choose addon') ?
                    <IonRow>
                      <IonCol>
                      {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                        <IonItem disabled={user.disableFlag}>
                          <IonRadioGroup className="app-font" value={user.answer} style={{ display: "flex", width: '500px !important' }}
                            onIonChange={e => { this.OnChangeRadio(e, this.selectedData.id, index, this.currentPageNumber) }}>
                            <IonLabel className="app-font"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b></IonLabel>
                            {user.answerValue.split(',').map((el: string, i: number) => (
                              <IonItem key={i} className="ion-item-top-adjust">
                                <IonLabel className='text-color'>{el}</IonLabel>
                                <IonRadio slot="start" value={el} disabled={user.disableFlag} />
                              </IonItem>))}
                          </IonRadioGroup>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'choose drop down') ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                          <IonSelect style={{ width: '500px !important', color: "#019849", fontWeight: "bold"}} disabled={user.disableFlag} value={user.answer} onIonChange={e => { this.OnChangeDropdown(e, this.selectedData.id, index, this.pageNmuber) }}>
                            {console.log("answerValue =", user.answerValue)}
                            {user.answerValue.split(',').map((el: string, k: number) => (
                              <IonSelectOption value={el}>{el}</IonSelectOption>
                            ))}
                          </IonSelect>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'drop down') ?
                    <IonRow>
                      <IonCol>
                        {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                        <IonItem>
                          <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView}{user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b></IonLabel>
                          <IonSelect style={{ width: '500px !important', color: "#019849", fontWeight: "bold"}} disabled={user.disableFlag} value={user.answer} onIonChange={e => { this.dropdownOnChange(e, index) }}>
                            {user.answerValue.split(',').map((el: string, k: number) => (
                              <IonSelectOption value={el}>{el}</IonSelectOption>
                            ))}
                          </IonSelect>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {((user.answerType === 'multiselect' && user.hideElement) || (user.answerType == 'drop down multiple')) ?
                    <IonRow>
                      <IonCol>
                      {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                        <IonItem>
                          <IonLabel className="app-font"><b>{user.questionNumber} {user.mobileView}{user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null} </b> &nbsp; <IonBadge>{user.answer}</IonBadge></IonLabel>
                          <IonSelect multiple={true} style={{ width: '500px !important', color: "#019849", fontWeight: "bold" }} disabled={user.disableFlag} onIonChange={e => { this.onChangeMultiDropDown(e, index) }}>
                            {user.answerValue.split(',').map((el: string, k: number) => (
                              <IonSelectOption value={el}>{el}</IonSelectOption>
                            ))}
                          </IonSelect>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}


                  {(user.answerType === 'range' || user.answerType === 'range inches' || user.answerType === 'range gallons' || user.answerType == 'range feet') ?
                    <IonRow>
                    <IonCol>
                    {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN' || user.answer == 0)) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                    <IonItem className="ion-range-adjust">
                      {(() => {
                        if (user.answerType == 'range' && !isNaN(user.answer)) {
                          return (
                            <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null} </b>&nbsp; <IonBadge>{this.state.data[index].answer}</IonBadge></IonLabel>
                          )
                        }
                        if (user.answerType == 'range' && isNaN(user.answer)) {
                          return (
                            <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null} </b>&nbsp; <IonBadge> 0 </IonBadge></IonLabel>
                          )
                        }
                      })()}

                      {(() => {
                        if (user.answerType == 'range inches' && !isNaN(user.answer)) {
                          return (
                            <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null} </b>&nbsp; <IonBadge>{this.state.data[index].answer + "''"}</IonBadge></IonLabel>
                          )
                        }
                        if (user.answerType == 'range inches' && isNaN(user.answer)) {
                          return (
                            <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null} </b>&nbsp; <IonBadge> 0'' </IonBadge></IonLabel>
                          )
                        }
                      })()}

                      {(() => {
                        if (user.answerType == 'range gallons' && !isNaN(user.answer)) {
                          return (
                            <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null} </b>&nbsp; <IonBadge>{this.state.data[index].answer + " gal"}</IonBadge></IonLabel>
                          )
                        }
                        if (user.answerType == 'range gallons' && isNaN(user.answer)) {
                          return (
                            <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null} </b>&nbsp; <IonBadge> 0 gal </IonBadge></IonLabel>
                          )
                        }
                      })()}

                      {(() => {
                        if (user.answerType == 'range feet' && !isNaN(user.answer)) {
                          return (
                            <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null} </b>&nbsp; <IonBadge>{this.state.data[index].answer + "'"}</IonBadge></IonLabel>
                          )
                        }
                        if (user.answerType == 'range feet' && isNaN(user.answer)) {
                          return (
                            <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null} </b>&nbsp; <IonBadge> 0' </IonBadge></IonLabel>
                          )
                        }
                      })()}
                      <IonRange pin={true} step={user.rangeStep} value={parseInt(user.answer)} disabled={user.disableFlag} min={user.answerValue[0]} max={user.answerValue[1]} color="secondary"
                        onIonChange={e => { this.rangeUpdate(e.detail.value, index) }}>
                        {(user.label) ? <IonBadge slot="start">{user.label[0]}</IonBadge> : null}
                        {(user.label) ? <IonBadge slot="end">{user.label[1]}</IonBadge> : null}
                      </IonRange>
                    </IonItem>
                    </IonCol>
                    </IonRow>
                    : null}

                </IonCardContent>

              )))}

              {(() => {

                if (this.state.inspectionDetailsTO.finalPage == false && this.state.inspectionDetailsTO.lastPage != true) {
                  return (
                    <IonRow>
                      <IonCol>
                        <IonButton
                          expand="block"
                          class="btncolor"
                          onClick={this.gotoNextPage}>                  
                          INSPECTION QUESTIONS
                        </IonButton>
                        {/* {(() => {
                          if(this.state.mandatory == true) {
                            return (
                              <IonText color="danger">
                                <p>This is a required field.</p>
                              </IonText>
                            );
                          }
                        })()} */}
                      </IonCol>
                    </IonRow>
                  )
                }
              })()}

              {(() => {

                if (this.state.headerTO.title == 'COMMENTS' && this.state.inspectionDetailsTO.currentPageNumber != 1) {
                  return (
                    <IonRow>
                      <IonCol>
                        <IonButton
                          expand="block"
                          class="btncolor"
                          onClick={() => this.submitInspection(this.selectedData.id)}>
                          SUBMIT
                        </IonButton>
                      </IonCol>
                    </IonRow>
                  )
                }
              })()}
            </IonCard>


          </IonContent>
        </IonPage>
      </InsPage>
    );
  };
}




export interface UserPhoto {
  filepath: string;
  webviewPath?: string;
}

const InsPage = styled(IonPage)`
ion-content{
  --ion-background-color:#cef2d0;
  
}
.ion-button{
  padding: 8px;
  background-color: #019849;
  color:#ffffff;
  border-radius: 4px;
}
ion-card-content{
  font-size: 14px !important;
}
ion-item{
  --ion-background-color:#fff;
}
.card_content{
  margin-top: 0;
  padding: 6px;
  bottom: 2px;
  color : #006884;
  background-color: #ffffff;
  font-size: 14px !important;
}
.btn_ins{
  padding: 8px;
  background-color: #019849;
  color: #fff;
}
.ion-item-top-adjust {
  position: relative;
  top: -10px;

}
.iontitle{
  color : #006884;
  font-size : 18px;
}

.mandatory{
  color : black;
  font-size : 14px;
}
.alert-wrapper ion-overlay-wrapper sc-ion-alert-md{
  min-width: -webkit-fit-content;
}

.ion-text-wrap {
  font-size : 15px;
}

.app-font {
font-size : 15px;
word-wrap: break-word;
}

.text-color {
  color : #019849;
  font-weight : bold;
}

`;

export default withIonLifeCycle(InspectionPage);